<template>
  <div class="page">
    <div id="container"></div>
    <div class="header"></div>
    <div class="light"></div>
<!--    <span class="title">正华通好城市绿色低碳综合治理平台</span>-->
    <!-- 标题与 PC 端顶部一致：取当前租户配置的平台标题 -->
    <span class="title">{{ systemTitle }}</span>

    <!-- 嵌在 PC 菜单 iframe 中时由 PC 端管理登录态，不显示退出 -->
    <button
      v-if="!embedded"
      class="logout-btn"
      type="button"
      title="退出登录"
      @click="handleLogout"
    >
      <i class="el-icon-switch-button"></i>
      <span>退出登录</span>
    </button>

    <div
      style="
        position: fixed;
        right: 15px;
        top: 25pt;
        color: white;
        font-size: 12px;
      "
    >
      <DateTimeBox :weather="weather" />
    </div>
    <div
      style="
        position: absolute;
        top: 66.5pt;
        left: 26.5pt;
        z-index: 99;
        pointer-events: auto;
      "
    >
      <ContentBox
        :width="485"
        title="数据总览"
        height="180px"
        :backgroundImage="dataTotalImage"
      >
        <div style="padding-top: 5px">
          <div class="overview-item-row">
            <ContentItem :item="dataTotal" @click.native="openOverviewList('cover', dataTotal)" />
            <ContentItem :item="deviceTotal" @click.native="openOverviewList('sensor', deviceTotal)" />
            <ContentItem :item="xunJian" @click.native="openOverviewList('alert', xunJian)" />
          </div>
          <div class="overview-item-row">
            <ContentItem :item="exeception" @click.native="openOverviewList('qingtao', exeception)" />
            <ContentItem :item="qingtao" @click.native="openOverviewList('archivedCustomer', qingtao)" />
            <ContentItem :item="carbon" @click.native="openOverviewList('contractCustomer', carbon)" />
          </div>
        </div>
      </ContentBox>

      <ContentBox
        :width="485"
        title="工作动态"
        height="529px"
        :backgroundImage="dataTotalImage5"
      >
        <div class="dynamic-scroll" ref="dynamicScroll">
          <div
            v-if="workDynamics.length === 0"
            style="color: #6f8fb3; font-size: 13px; text-align: center; padding-top: 60px"
          >
            暂无动态
          </div>
          <div
            v-else
            class="dynamic-loop"
            ref="dynamicLoop"
            :class="{ 'dynamic-loop-run': dynamicLoopActive }"
          >
            <div class="dynamic-half">
              <div
                v-for="(item, index) in workDynamics"
                :key="'a-' + index"
                class="dynamic-item"
                @click="openWorkDynamicsDetail(item)"
              >
                <span
                  :style="{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    flex: 'none',
                    margin: '6px 10px 0 2px',
                    background: eventColor(item.eventType),
                    boxShadow: '0 0 6px ' + eventColor(item.eventType),
                  }"
                ></span>
                <div style="flex: 1; min-width: 0">
                  <div
                    style="
                      color: #ffffff;
                      font-size: 13px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ item.eventDesc }}
                  </div>
                  <div style="color: #6f8fb3; font-size: 11px; margin-top: 2px">
                    {{ formatRelativeTime(item.eventTime) }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 第二份副本：滚到底部时无缝衔接第一条 -->
            <div class="dynamic-half" aria-hidden="true">
              <div
                v-for="(item, index) in workDynamics"
                :key="'b-' + index"
                class="dynamic-item"
                @click="openWorkDynamicsDetail(item)"
              >
                <span
                  :style="{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    flex: 'none',
                    margin: '6px 10px 0 2px',
                    background: eventColor(item.eventType),
                    boxShadow: '0 0 6px ' + eventColor(item.eventType),
                  }"
                ></span>
                <div style="flex: 1; min-width: 0">
                  <div
                    style="
                      color: #ffffff;
                      font-size: 13px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ item.eventDesc }}
                  </div>
                  <div style="color: #6f8fb3; font-size: 11px; margin-top: 2px">
                    {{ formatRelativeTime(item.eventTime) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentBox>
    </div>
    <div
      class="right-panel"
      style="
        position: absolute;
        top: 66.5pt;
        right: 26.5pt;
        z-index: 99;
        pointer-events: auto;
      "
    >
      <ContentBox
        :width="485"
        title="任务总览"
        height="360px"
        :backgroundImage="dataTotalImage3"
      >
        <div class="task-overview">
          <div
            v-for="biz in taskOverview"
            :key="biz.type"
            class="task-group"
            :class="{ 'task-group-septic': biz.type === 'septic' }"
          >
            <div class="task-group-title">{{ biz.name }}</div>
            <div class="task-stats">
              <div class="task-stat task-stat-dispatched" @click="openTaskDetail(biz, 'dispatched')">
                <span class="task-stat-label">派单</span>
                <strong class="task-stat-value">{{ biz.dispatched ?? 0 }}</strong>
              </div>
              <div class="task-stat task-stat-transit" @click="openTaskDetail(biz, 'inTransit')">
                <span class="task-stat-label">在途</span>
                <strong class="task-stat-value">{{ biz.inTransit ?? 0 }}</strong>
              </div>
              <div class="task-stat task-stat-finished" @click="openTaskDetail(biz, 'finished')">
                <span class="task-stat-label">完成</span>
                <strong class="task-stat-value">{{ biz.finished ?? 0 }}</strong>
              </div>
              <div v-if="biz.type === 'septic'" class="task-stat task-stat-residue" @click="openResidueDetail">
                <span class="task-stat-label">废渣</span>
                <strong class="task-stat-value">{{ residueAmount }}<small>袋</small></strong>
              </div>
            </div>
          </div>
        </div>
      </ContentBox>
      <ContentBox
        :width="485"
        title="池体总览"
        height="328px"
        :backgroundImage="dataTotalImage4"
      >
        <div style="height: 100%">
          <div class="pool-overview-grid">
            <CTContentItem
              v-for="(item, index) in poolOverviewItems"
              :key="item.spotTypeId || index"
              :item="item"
              :color="poolOverviewColors[index % poolOverviewColors.length]"
              @click.native="openPoolDetail(item)"
            ></CTContentItem>
          </div>
        </div>
      </ContentBox>
      <ContentBox
        :width="485"
        title="车辆实时监控"
        class="fill-box"
        :backgroundImage="dataTotalImage2"
      >
        <div class="vehicle-monitor">
          <div v-if="carMarkerData.length === 0" class="vehicle-empty">
            暂无车辆数据
          </div>
          <template v-else>
            <div class="vehicle-row vehicle-row-header">
              <span class="vehicle-name">车辆</span>
              <span class="vehicle-status">状态</span>
              <span class="vehicle-driver">联系人</span>
              <span class="vehicle-action">操作</span>
            </div>
            <div class="vehicle-list list-container">
              <div
                v-for="car in sortedCarMarkerData"
                :key="car.carId || car.id || car.carNo"
                class="vehicle-row"
                @click="selectCar(car)"
              >
                <span class="vehicle-name" :title="car.carNo">{{ car.carNo || "--" }}</span>
                <span
                  class="vehicle-status vehicle-status-tag"
                  :class="`vehicle-status-${getCarStatusMeta(car).type}`"
                >
                  {{ getCarStatusMeta(car).label }}
                </span>
                <span class="vehicle-driver" :title="car.carContactUser">{{ car.carContactUser  || "--" }}</span>
                <button v-if="car.status !== 'UNBOUND' && car.gpsBound !== false" class="vehicle-track" type="button" @click.stop="focusCar(car)">
                  轨迹
                </button>
              </div>
            </div>
          </template>
        </div>
      </ContentBox>
    </div>

    <!--点位点击弹窗-->
    <div
      class="spot-info-bg"
      :style="{ backgroundImage: `url(${spotBGImage})` }"
      v-show="clickedSpot && clickedSpot.id"
    >
      <div
        style="
          height: 58px;
          position: relative;
          flex: none;
          display: flex;
          align-items: center;
          letter-spacing: 1px;
        "
      >
        <span
          style="
            font-size: 20px;
            font-style: italic;
            font-weight: bold;
            margin-left: 45px;
          "
          >智能井盖编号:</span
        >
        <span style="font-size: 18px; font-weight: bold; margin-left: 15px">{{
          clickedSpot.code
        }}</span>
        <div
          class="close-btn"
          :style="{ backgroundImage: `url(${spotClose})` }"
          @click="closeSpotPopup"
        ></div>
      </div>

      <div style="flex: 1; display: flex; flex-direction: column">
        <div class="item item-border" style="letter-spacing: 1px">
          归属客户：{{ clickedSpot.belongCompany }}
        </div>
        <div class="item item-border" style="letter-spacing: 1px">
          联系电话：{{ clickedSpot.contactPhone }}
        </div>
<!--        <div class="item item-border" style="letter-spacing: 1px">
          井盖位置：{{ clickedSpot.address }}
        </div>-->
        <div class="item" style="display: flex; font-weight: bold">
          <div style="flex: 1; color: #0084f3; letter-spacing: 2px">
            设备状态:{{ clickedSpot.deviceStatus }}
          </div>
          <div
            style="
              flex: 1;
              color: #00f350;
              text-align: right;
              padding-right: 30px;
              letter-spacing: 2px;
            "
          >
            电量:{{ clickedSpot.power }}%
          </div>
        </div>

        <div
          :style="{ backgroundImage: `url(${waterImg})`, flex: 1 }"
          class="water-container"
        >
          <div
            id="waterPie"
            style="
              width: 250px;
              height: 220px;
              position: absolute;
              border-radius: 100px;
              left: 50%;
              top: -13px;
              transform: translate(-50%, 0%);
            "
          ></div>

          <div
            style="
              position: absolute;
              font-style: italic;
              left: 50%;
              top: -25px;
              transform: translate(-50%, 0);
              background-color: rgba(50, 143, 255, 0.5);
              border-radius: 20px;
              padding: 10px 10px;
            "
          >
            <span>碳积分:</span>
            <span>{{ clickedSpot.carbonScore }}</span>
            <div
              class="arrow-container"
              style="
                position: absolute;
                left: 50%;
                transform: translate(-25%, 0);
                bottom: -13px;
                z-index: 9999999;
              "
            >
              <span></span>
            </div>
          </div>

          <div
            style="
              position: absolute;
              left: 50%;
              top: 50px;
              transform: translate(-50%, 0);
            "
          >
            <span style="font-size: 18px; font-weight: bold">{{
              clickedSpot.deep
            }}</span>
            <span style="font-size: 12px; margin-left: 5px">ml</span>
          </div>

          <div
            style="
              position: absolute;
              width: 26%;
              border: 0px solid blue;
              top: 40px;
              left: 45px;
            "
          >
            <div style="display: flex; align-items: center">
              <img :src="rectImg" /><span
                style="
                  margin-left: 10px;
                  color: rgba(255, 255, 255, 0.5);
                  font-size: 15px;
                "
                >甲烷</span
              >
            </div>
            <div style="margin-top: 6px">
              <span style="font-size: 18px; font-weight: bold">{{
                clickedSpot.ch4
              }}</span
              ><span
                style="
                  letter-spacing: 2px;
                  margin-left: 5px;
                  color: rgba(255, 255, 255, 0.5);
                "
                >ppm</span
              >
            </div>
          </div>

          <div
            style="
              position: absolute;
              width: 26%;
              border: 0px solid blue;
              top: 40px;
              right: 42px;
            "
          >
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
              "
            >
              <span
                style="
                  margin-right: 10px;
                  color: rgba(255, 255, 255, 0.5);
                  font-size: 15px;
                "
                >氨气</span
              ><img :src="rectImg" />
            </div>
            <div style="margin-top: 6px; text-align: right">
              <span style="font-size: 18px; font-weight: bold">{{
                clickedSpot.anqi
              }}</span
              ><span
                style="
                  letter-spacing: 2px;
                  margin-left: 5px;
                  color: rgba(255, 255, 255, 0.5);
                "
                >ppm</span
              >
            </div>
          </div>

          <div
            style="
              position: absolute;
              width: 26%;
              border: 0px solid blue;
              top: 115px;
              left: 45px;
            "
          >
            <div style="display: flex; align-items: center">
              <img :src="rectImg" /><span
                style="
                  margin-left: 10px;
                  color: rgba(255, 255, 255, 0.5);
                  font-size: 15px;
                "
                >二氧化碳</span
              >
            </div>
            <div style="margin-top: 6px">
              <span style="font-size: 18px; font-weight: bold">{{
                clickedSpot.ch4
              }}</span
              ><span
                style="
                  letter-spacing: 2px;
                  margin-left: 5px;
                  color: rgba(255, 255, 255, 0.5);
                "
                >ppm</span
              >
            </div>
          </div>

          <div
            style="
              position: absolute;
              width: 26%;
              border: 0px solid blue;
              top: 115px;
              right: 42px;
            "
          >
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
              "
            >
              <span
                style="
                  margin-right: 10px;
                  color: rgba(255, 255, 255, 0.5);
                  font-size: 15px;
                "
                >硫化氢</span
              ><img :src="rectImg" />
            </div>
            <div style="margin-top: 6px; text-align: right">
              <span style="font-size: 18px; font-weight: bold">{{
                clickedSpot.anqi
              }}</span
              ><span
                style="
                  letter-spacing: 2px;
                  margin-left: 5px;
                  color: rgba(255, 255, 255, 0.5);
                "
                >ppm</span
              >
            </div>
          </div>
        </div>

        <div
          class="item"
          style="display: flex; font-weight: bold; height: 50px"
        >
          <div style="flex: 1; color: #00f0f3; letter-spacing: 2px">
            巡检次数:{{ clickedSpot.xjNum }}次
          </div>
          <div
            style="
              flex: 1;
              color: #00f0f3;
              text-align: right;
              padding-right: 30px;
              letter-spacing: 2px;
            "
          >
            清掏次数:{{ clickedSpot.qtNum }}次
          </div>
        </div>
        <div
          class="item"
          style="display: flex; font-weight: bold; height: 50px"
        >
          <div style="flex: 1; color: #f32800; letter-spacing: 2px">
            异常记录:{{ clickedSpot.ycNum }}次
          </div>
        </div>
        <div style="height: 20px"></div>
      </div>
    </div>

    <!--点位点击弹窗-记录-->
    <div
      class="spot-info-bg2"
      :style="{ backgroundImage: `url(${spotBGRecordImage})` }"
      v-show="clickedSpot && clickedSpot.id && showClickedSpot"
    >
      <div
        style="
          height: 58px;
          position: relative;
          flex: none;
          display: flex;
          align-items: center;
          letter-spacing: 1px;
          flex: none;
        "
      >
        <span
          style="
            cursor: pointer;
            font-size: 20px;
            font-style: italic;
            font-weight: bold;
            margin-left: 45px;
          "
          :style="
            clickBtn === 1
              ? { color: 'rgba(255,255,255,1.0)' }
              : { color: 'rgba(255,255,255,0.5)' }
          "
          @click="loadRecordList(1)"
          >清掏记录</span
        >
        <span
          style="
            cursor: pointer;
            font-size: 20px;
            font-style: italic;
            font-weight: bold;
            margin-left: 45px;
          "
          :style="
            clickBtn === 2
              ? { color: 'rgba(255,255,255,1.0)' }
              : { color: 'rgba(255,255,255,0.5)' }
          "
          @click="loadRecordList(2)"
          >异常记录</span
        >
        <span
          style="
            cursor: pointer;
            font-size: 20px;
            font-style: italic;
            font-weight: bold;
            margin-left: 45px;
          "
          :style="
            clickBtn === 3
              ? { color: 'rgba(255,255,255,1.0)' }
              : { color: 'rgba(255,255,255,0.5)' }
          "
          @click="loadRecordList(3)"
          >巡检记录</span
        >
        <div
          class="close-btn"
          :style="{ backgroundImage: `url(${spotClose})` }"
          @click="closeSpotPopup"
        ></div>
      </div>

      <!--巡检记录-->
      <div style="flex: 1; position: relative" v-if="clickBtn === 3">
        <div
          v-if="xunjianList.length === 0"
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white;
            font-size: 16px;
          "
        >
          暂无数据
        </div>
        <div
          v-if="xunjianList.length > 0"
          style="
            height: calc(100% - 30px);
            width: calc(100% - 20px);
            margin: 10px auto;
          "
        >
          <div
            style="
              font-size: 18px;
              color: rgba(255, 255, 255, 1);
              font-weight: bold;
              display: flex;
              text-align: center;
              justify-content: space-between;
              align-items: center;
              height: 50px;
              border-bottom: 1px solid rgba(255, 255, 255, 0.2);
            "
          >
            <span style="width: 16.6%; flex: 1">井盖损坏</span>
            <span style="width: 16.6%; flex: 1">井盖移位</span>
            <span style="width: 16.6%; flex: 1">存在异味</span>
            <span style="width: 16.6%; flex: 1">是否冒泡</span>
            <span style="width: 16.6%; flex: 1">巡检员</span>
            <span style="width: 16.6%; flex: 1">日期</span>
          </div>

          <div
            class="list-container"
            style="height: 470px; width: 100%; overflow-y: auto"
          >
            <div
              v-for="item in xunjianList"
              :key="item.id"
              style="
                font-size: 16px;
                font-weight: bold;
                display: flex;
                text-align: center;
                justify-content: space-between;
                align-items: center;
                height: 50px;
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
              "
            >
              <span style="width: 16.6%; flex: 1; overflow: hidden">{{
                item.xunhai ? "是" : "否"
              }}</span>
              <span style="width: 16.6%; flex: 1; overflow: hidden">{{
                item.weiyi ? "是" : "否"
              }}</span>
              <span style="width: 16.6%; flex: 1; overflow: hidden">{{
                item.yiwei ? "是" : "否"
              }}</span>
              <span style="width: 16.6%; flex: 1; overflow: hidden">{{
                item.maochu ? "是" : "否"
              }}</span>
              <span style="width: 16.6%; flex: 1; overflow: hidden">{{
                item.userName
              }}</span>
              <span style="width: 16.6%; flex: 1; overflow: hidden">{{
                item.createTime
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <!--清掏记录-->
      <div style="flex: 1; position: relative" v-if="clickBtn === 1">
        <div
          v-if="qingTaoList.length === 0"
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white;
            font-size: 16px;
          "
        >
          暂无数据
        </div>
        <div
          v-if="qingTaoList.length > 0"
          style="
            height: calc(100% - 30px);
            width: calc(100% - 20px);
            margin: 10px auto;
          "
        >
          <div
            style="
              font-size: 18px;
              color: rgba(255, 255, 255, 1);
              font-weight: bold;
              display: flex;
              text-align: center;
              justify-content: space-between;
              align-items: center;
              height: 50px;
              border-bottom: 1px solid rgba(255, 255, 255, 0.2);
            "
          >
            <span style="width: 25%; flex: 1">井盖编码</span>
            <span style="width: 25%; flex: 1">井盖名称</span>
            <span style="width: 25%; flex: 1">开始时间</span>
            <span style="width: 25%; flex: 1">结束时间</span>
          </div>

          <div
            class="list-container"
            style="height: 470px; width: 100%; overflow-y: auto"
          >
            <div
              @click="clickQTRow(item)"
              v-for="item in qingTaoList"
              :key="item.id"
              style="
                cursor: pointer;
                font-size: 16px;
                font-weight: bold;
                display: flex;
                text-align: center;
                justify-content: space-between;
                align-items: center;
                height: 50px;
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
              "
            >
              <span style="width: 25%; flex: 1; overflow: hidden">{{
                item.qrCode
              }}</span>
              <span style="width: 25%; flex: 1; overflow: hidden">{{
                item.name
              }}</span>
              <span style="width: 25%; flex: 1; overflow: hidden">{{
                item.startTimeStr
              }}</span>
              <span style="width: 25%; flex: 1; overflow: hidden">{{
                item.endTimeStr
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <!--异常上报-->
      <div style="flex: 1; position: relative" v-if="clickBtn === 2">
        <div
          v-if="exceptionList.length === 0"
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white;
            font-size: 16px;
          "
        >
          暂无数据
        </div>
        <div
          v-if="exceptionList.length > 0"
          style="
            height: calc(100% - 30px);
            width: calc(100% - 20px);
            margin: 10px auto;
          "
        >
          <div
            style="
              font-size: 18px;
              color: rgba(255, 255, 255, 1);
              font-weight: bold;
              display: flex;
              text-align: center;
              justify-content: space-between;
              align-items: center;
              height: 50px;
              border-bottom: 1px solid rgba(255, 255, 255, 0.2);
            "
          >
            <span style="width: 20%; flex: 1">井盖损坏</span>
            <span style="width: 20%; flex: 1">井盖移位</span>
            <span style="width: 20%; flex: 1">存在异味</span>
            <span style="width: 20%; flex: 1">是否冒泡</span>
            <span style="width: 20%; flex: 1">日期</span>
          </div>

          <div
            class="list-container"
            style="height: 470px; width: 100%; overflow-y: auto"
          >
            <div
              v-for="item in exceptionList"
              :key="item.id"
              style="
                font-size: 16px;
                font-weight: bold;
                display: flex;
                text-align: center;
                justify-content: space-between;
                align-items: center;
                height: 50px;
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
              "
            >
              <span style="width: 20%; flex: 1; overflow: hidden">{{
                item.xunhai ? "是" : "否"
              }}</span>
              <span style="width: 20%; flex: 1; overflow: hidden">{{
                item.weiyi ? "是" : "否"
              }}</span>
              <span style="width: 20%; flex: 1; overflow: hidden">{{
                item.yiwei ? "是" : "否"
              }}</span>
              <span style="width: 20%; flex: 1; overflow: hidden">{{
                item.maochu ? "是" : "否"
              }}</span>
              <span style="width: 20%; flex: 1; overflow: hidden">{{
                item.createTime
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--车辆点击弹窗-->
    <div
      class="car-info-bg"
      :style="{ backgroundImage: `url(${carBGImage})` }"
      v-show="clickedCar && clickedCar.carNo"
    >
      <div
        style="
          height: 58px;
          position: relative;
          flex: none;
          display: flex;
          align-items: center;
          letter-spacing: 1px;
        "
      >
        <span
          style="
            font-size: 20px;
            font-style: italic;
            font-weight: bold;
            margin-left: 45px;
          "
          >{{ clickedCar.carTypeName }}：{{ clickedCar.carNo }}</span
        >
        <div
          class="close-btn"
          :style="{ backgroundImage: `url(${spotClose})` }"
          @click="closeCarPopup"
        ></div>
      </div>

      <div style="flex: 1; display: flex; flex-direction: column">
        <div class="item item-border" style="letter-spacing: 1px">
          车主信息：{{ clickedCar.carContactUser }}
          {{ clickedCar.carContactPhone }}
        </div>
        <div class="item item-border" style="letter-spacing: 1px">
          任务状态：{{ clickedCar.statuStr }}
        </div>
        <div class="item item-border" style="letter-spacing: 1px">
          车辆位置：{{ clickedCar.address }}
        </div>

        <div
          class="item"
          style="display: flex; font-weight: bold"
          v-show="clickedCar.cameraDeviceSerial"
        >
          <div
            style="
              flex: 1;
              color: #0084f3;
              letter-spacing: 2px;
              font-size: 20px;
              color: #00f0f3;
              cursor: pointer;
            "
            @click="playCamera"
          >
            打开车载摄像头
          </div>
        </div>
      </div>
    </div>

    <!--摄像头点击弹窗-->
    <div
      :class="isFullScreen ? 'fullscreen-dialog-camera' : 'camera-mini-bg'"
      :style="
        !isFullScreen ? { backgroundImage: `url(${spotBGRecordImage})` } : {}
      "
      v-show="clickedCar && clickedCar.carNo && showCamera"
    >
      <div
        style="
          width: 100%;
          height: 58px;
          position: relative;
          flex: none;
          display: flex;
          align-items: center;
          letter-spacing: 1px;
        "
      >
        <span
          style="
            cursor: pointer;
            font-size: 20px;
            font-style: italic;
            font-weight: bold;
            margin-left: 45px;
          "
          >设备{{ clickedCar.cameraDeviceSerial }}</span
        >

        <div
          style="
            position: absolute;
            height: 100%;
            width: 80px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            right: 10px;
            border: 0px solid blue;
          "
        >
          <div @click="fullScreenClick">
            <!-- <img
              :src="fullScreen"
              style="width: 25px; height: 25px"
              v-show="!isFullScreen"
            /> -->
            <img
              :src="fullScreenExit"
              style="width: 25px; height: 25px"
              v-show="isFullScreen"
            />
          </div>
          <div @click="closeCameraPopup">
            <img :src="closeCameraBtn" style="width: 25px; height: 25px" />
          </div>
        </div>
      </div>

      <div
        ref="viewtools"
        id="video-container"
        style="
          margin: auto auto;
          height: 98%;
          width: 98%;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 0px solid red;
        "
      ></div>
      <div
        v-if="offline_enable"
        style="position: absolute; left: 35%; top: 50%; font-size: 20px"
      >
        当前设备未在线
      </div>
    </div>

    <!--清掏记录详情-->
    <div
      class="spot-info-bg3"
      :style="{ backgroundImage: `url(${spotBGImage})` }"
      v-show="clickedQTRecord && clickedQTRecord.id"
    >
      <div
        style="
          height: 58px;
          position: relative;
          flex: none;
          display: flex;
          align-items: center;
          letter-spacing: 1px;
        "
      >
        <span
          style="
            font-size: 20px;
            font-style: italic;
            font-weight: bold;
            margin-left: 45px;
          "
          >清掏记录详情</span
        >
        <div
          class="close-btn"
          :style="{ backgroundImage: `url(${spotClose})` }"
          @click="closeQTPopup"
        ></div>
      </div>

      <div
        style="flex: 1; display: flex; flex-direction: column; overflow-y: auto"
      >
        <div class="item item-border" style="letter-spacing: 1px">
          任务编号：{{ clickedQTRecord.code }}
        </div>
        <div class="item item-border" style="letter-spacing: 1px">
          开始时间：{{ clickedQTRecord.startTimeStr }}
        </div>
        <div class="item item-border" style="letter-spacing: 1px">
          结束时间：{{ clickedQTRecord.endTimeStr }}
        </div>
        <div class="item item-border" style="letter-spacing: 1px">
          时长：{{ clickedQTRecord.workTime }}
        </div>
        <div
          class="item item-border"
          style="letter-spacing: 1px; display: flex"
        >
          <div style="width: 90px; flex: none">清掏人员：</div>
          <div style="display: flex; flex-wrap: wrap; flex: 1">
            <span
              style="margin-right: 8px"
              v-for="(p, index) in (clickedQTRecord.contacts || []).filter(Boolean)"
              :key="'c' + index"
              >{{ p.name }}</span
            >
          </div>
        </div>
        <div
          class="item item-border"
          style="letter-spacing: 1px; display: flex"
        >
          <div style="width: 90px; flex: none">清掏车辆：</div>
          <div style="display: flex; flex-wrap: wrap; flex: 1">
            <span
              style="margin-right: 8px"
              v-for="(p, index) in (clickedQTRecord.cars || []).filter(Boolean)"
              :key="'v' + index"
              >{{ p.carNo }}</span
            >
          </div>
        </div>
        <div class="item item-border" style="letter-spacing: 1px">
          清掏前有毒气体：{{ clickedQTRecord.before }}ppm
        </div>
        <div class="item item-border" style="letter-spacing: 1px">
          清掏后有毒气体：{{ clickedQTRecord.after }}ppm
        </div>
        <div
          class="item item-border"
          style="letter-spacing: 1px"
          v-if="clickedQTRecord.remark"
        >
          <div style="width: 90px; flex: none">施工备注：</div>
          {{ clickedQTRecord.remark }}
        </div>
        <div class="item item-border" style="letter-spacing: 1px">
          施工图片：
        </div>
        <!--.item 固定高 60px，分组图片必须放在其外，随内容区滚动，否则溢出遮挡相邻行-->
        <div style="z-index: 108; padding: 5px 0 5px 45px; flex: none">
          <div
            style="
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              margin-bottom: 6px;
            "
            v-for="group in qtImageGroups"
            :key="group.type"
          >
            <span
              style="width: 64px; flex: none; font-size: 14px; font-style: italic"
              >{{ group.label }}：</span
            >
            <template v-if="group.urls.length > 0">
              <el-image
                v-for="(u, i) in group.urls"
                :key="group.type + '-' + i"
                style="width: 60px; height: 60px; margin-right: 8px"
                :src="u"
                :preview-src-list="group.urls"
              >
              </el-image>
            </template>
            <span
              v-else
              style="color: rgba(255, 255, 255, 0.5); font-size: 14px"
              >暂无</span
            >
          </div>
        </div>

        <div style="height: 0px"></div>
      </div>
    </div>

    <!--数据总览点击明细列表-->
    <div
      class="overview-list-bg"
      :style="{ backgroundImage: `url(${spotBGRecordImage})` }"
      v-show="overviewDialog.visible"
    >
      <div class="overview-dialog-header">
        <span class="overview-dialog-title">{{ overviewDialog.title }}</span>
        <div
          class="close-btn"
          :style="{ backgroundImage: `url(${spotClose})` }"
          @click="closeOverviewList"
        ></div>
      </div>

      <!-- 表头 -->
      <div class="overview-dialog-toolbar">
        <el-input
          v-model="overviewDialog.keyword"
          class="overview-dialog-search"
          clearable
          size="small"
          :placeholder="overviewFilterConfig.placeholder"
          prefix-icon="el-icon-search"
          @input="handleOverviewSearch"
          @keyup.enter.native="handleOverviewSearch"
          @clear="handleOverviewSearch"
        ></el-input>
        <el-select
          v-if="overviewFilterConfig.selectProp"
          v-model="overviewDialog.selectValue"
          class="overview-dialog-select"
          clearable
          size="small"
          :placeholder="overviewFilterConfig.selectPlaceholder"
          popper-class="overview-dialog-select-dropdown"
          @change="handleOverviewSearch"
        >
          <el-option
            v-for="option in overviewSelectOptions"
            :key="option"
            :label="option"
            :value="option"
          ></el-option>
        </el-select>
        <el-button size="small" type="primary" icon="el-icon-search" @click="handleOverviewSearch">
          查询
        </el-button>
      </div>

      <div class="ov-table-scroll">
        <div class="ov-table-content">
          <div class="ov-thead">
            <span v-for="col in overviewColumns" :key="col.prop" class="ov-col" :style="{ width: col.width }">{{
              col.label
            }}</span>
          </div>
      <!-- 列表 -->
          <div class="list-container ov-body" v-loading="overviewDialog.loading">
            <template v-if="overviewPagedList.length > 0">
              <div
                v-for="(row, idx) in overviewPagedList"
                :key="row.id || idx"
                class="ov-row"
                :class="{ 'ov-row-clickable': overviewRowClickable }"
                @click="handleOverviewRowClick(row)"
              >
                <span
                  v-for="col in overviewColumns"
                  :key="col.prop"
                  class="ov-col ov-cell"
                  :style="{ width: col.width }"
                  :title="String(overviewCellValue(row, col.prop))"
                >
                  {{ overviewCellValue(row, col.prop) }}
                </span>
              </div>
            </template>
            <div v-if="!overviewDialog.loading && overviewPagedList.length === 0" class="ov-empty">暂无数据</div>
          </div>
        </div>
      </div>
      <div class="overview-dialog-footer">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :total="overviewTotal"
          :current-page="overviewDialog.page"
          :page-size="overviewDialog.pageSize"
          :page-sizes="overviewPageSizes"
          @size-change="handleOverviewPageSizeChange"
          @current-change="handleOverviewPageChange"
        ></el-pagination>
      </div>
    </div>

    <!--明细行下钻：历史清掏记录列表（点击记录查看清掏明细）-->
    <div
      class="overview-list-bg history-qt-bg"
      :style="{ backgroundImage: `url(${spotBGRecordImage})` }"
      v-show="historyQingTaoDialog.visible"
    >
      <div class="overview-dialog-header">
        <span class="overview-dialog-title">{{ historyQingTaoDialog.title }}</span>
        <div
          class="close-btn"
          :style="{ backgroundImage: `url(${spotClose})` }"
          @click="closeHistoryQingTao"
        ></div>
      </div>
      <!-- 搜索栏：与明细列表弹窗同款 -->
      <div class="overview-dialog-toolbar">
        <el-input
          v-model="historyQingTaoDialog.keyword"
          class="overview-dialog-search"
          clearable
          size="small"
          placeholder="请输入井盖编码/点位名称/任务编号"
          prefix-icon="el-icon-search"
          @input="handleHistorySearch"
          @keyup.enter.native="handleHistorySearch"
          @clear="handleHistorySearch"
        ></el-input>
        <el-button size="small" type="primary" icon="el-icon-search" @click="handleHistorySearch">
          查询
        </el-button>
      </div>
      <div class="ov-table-scroll">
        <div class="ov-table-content">
          <div class="ov-thead">
            <span class="ov-col" style="width: 22%">井盖编码</span>
            <span class="ov-col" style="width: 24%">点位名称</span>
            <span class="ov-col" style="width: 27%">开始时间</span>
            <span class="ov-col" style="width: 27%">结束时间</span>
          </div>
          <div class="list-container ov-body" v-loading="historyQingTaoDialog.loading">
            <template v-if="historyQingTaoPagedList.length > 0">
              <div
                v-for="item in historyQingTaoPagedList"
                :key="item.id"
                class="ov-row ov-row-clickable"
                @click="showQTRecordDetail(item, false)"
              >
                <span class="ov-col ov-cell" style="width: 22%">{{ item.qrCode || "--" }}</span>
                <span class="ov-col ov-cell" style="width: 24%">{{ item.name || "--" }}</span>
                <span class="ov-col ov-cell" style="width: 27%">{{ item.startTimeStr || "--" }}</span>
                <span class="ov-col ov-cell" style="width: 27%">{{ item.endTimeStr || "--" }}</span>
              </div>
            </template>
            <div
              v-if="!historyQingTaoDialog.loading && historyQingTaoPagedList.length === 0"
              class="ov-empty"
            >
              暂无清掏记录
            </div>
          </div>
        </div>
      </div>
      <div class="overview-dialog-footer">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :total="historyQingTaoTotal"
          :current-page="historyQingTaoDialog.page"
          :page-size="historyQingTaoDialog.pageSize"
          :page-sizes="overviewPageSizes"
          @size-change="handleHistoryPageSizeChange"
          @current-change="handleHistoryPageChange"
        ></el-pagination>
      </div>
    </div>

    <div
      class="dynamic-detail-bg"
      :style="{ backgroundImage: `url(${spotBGRecordImage})` }"
      v-show="dynamicDetailDialog.visible"
    >
      <div class="overview-dialog-header">
        <span class="overview-dialog-title">{{ dynamicDetailTitle }}</span>
        <div
          class="close-btn"
          :style="{ backgroundImage: `url(${spotClose})` }"
          @click="closeWorkDynamicsDetail"
        ></div>
      </div>
      <div class="dynamic-detail-body" v-loading="dynamicDetailDialog.loading">
        <template v-if="dynamicDetailDialog.mode !== 'task'">
          <div class="dynamic-detail-field">
            <span class="dynamic-detail-label">事件类型</span>
            <span>{{ overviewCellValue(dynamicDetailDialog.item, "eventType") }}</span>
          </div>
          <div class="dynamic-detail-field dynamic-detail-description">
            <span class="dynamic-detail-label">事件描述</span>
            <span>{{ overviewCellValue(dynamicDetailDialog.item, "eventDesc") }}</span>
          </div>
          <div class="dynamic-detail-field">
            <span class="dynamic-detail-label">发生时间</span>
            <span>{{ overviewCellValue(dynamicDetailDialog.item, "eventTime") }}</span>
          </div>
        </template>
        <template v-if="dynamicDetailDialog.task">
          <div class="dynamic-detail-section">关联工单详情</div>
          <div class="dynamic-detail-field">
            <span class="dynamic-detail-label">任务编号</span>
            <span>{{ dynamicTaskValue("code") }}</span>
          </div>
          <div class="dynamic-detail-field">
            <span class="dynamic-detail-label">客户</span>
            <span>{{ dynamicTaskValue("enterpriseName") }}</span>
          </div>
          <div class="dynamic-detail-field">
            <span class="dynamic-detail-label">任务类型</span>
            <span>{{ dynamicTaskType }}</span>
          </div>
          <div class="dynamic-detail-field">
            <span class="dynamic-detail-label">客户联系人</span>
            <span>{{ dynamicTaskContact }}</span>
          </div>
          <div class="dynamic-detail-field">
            <span class="dynamic-detail-label">联系电话</span>
            <span>{{ dynamicTaskPhone }}</span>
          </div>
          <div class="dynamic-detail-field">
            <span class="dynamic-detail-label">作业地址</span>
            <span>{{ dynamicTaskAddress }}</span>
          </div>
          <div class="dynamic-detail-field">
            <span class="dynamic-detail-label">作业人员</span>
            <span>{{ dynamicTaskPeople }}</span>
          </div>
          <div class="dynamic-detail-field">
            <span class="dynamic-detail-label">作业车辆</span>
            <span>{{ dynamicTaskCars }}</span>
          </div>
          <div class="dynamic-detail-field">
            <span class="dynamic-detail-label">任务状态</span>
            <span>{{ dynamicTaskStatus }}</span>
          </div>
          <div class="dynamic-detail-field">
            <span class="dynamic-detail-label">计划时间</span>
            <span>{{ dynamicTaskTime }}</span>
          </div>
          <div class="dynamic-detail-field" v-if="dynamicTaskValue('startTime') !== '--'">
            <span class="dynamic-detail-label">开始时间</span>
            <span>{{ dynamicTaskValue("startTime") }}</span>
          </div>
          <div class="dynamic-detail-field" v-if="dynamicTaskFinishTime !== '--'">
            <span class="dynamic-detail-label">完成时间</span>
            <span>{{ dynamicTaskFinishTime }}</span>
          </div>
          <div class="dynamic-detail-field" v-if="dynamicTaskValue('allocationTime') !== '--'">
            <span class="dynamic-detail-label">分配时间</span>
            <span>{{ dynamicTaskValue("allocationTime") }}</span>
          </div>
          <div class="dynamic-detail-field" v-if="dynamicTaskValue('remark') !== '--'">
            <span class="dynamic-detail-label">任务备注</span>
            <span>{{ dynamicTaskValue("remark") }}</span>
          </div>
          <div class="dynamic-detail-field" v-if="dynamicTaskContent !== '--'">
            <span class="dynamic-detail-label">作业要求</span>
            <span>{{ dynamicTaskContent }}</span>
          </div>
        </template>
        <div
          v-if="dynamicDetailDialog.mode === 'task' && !dynamicDetailDialog.loading && !dynamicDetailDialog.task"
          class="dynamic-detail-field"
        >
          <span class="dynamic-detail-label">任务信息</span>
          <span>暂无详情</span>
        </div>
        <template v-if="dynamicHasTaskImages">
          <div class="dynamic-detail-section">施工照片</div>
          <div
            class="dynamic-detail-field dynamic-detail-photo-field"
            v-for="group in dynamicTaskImageGroups"
            :key="group.type"
          >
            <span class="dynamic-detail-label">{{ group.label }}</span>
            <div class="dynamic-detail-photo-list" v-if="group.urls.length">
              <el-image
                v-for="(url, idx) in group.urls"
                :key="url + '-' + idx"
                class="dynamic-detail-photo"
                :src="url"
                fit="cover"
                :preview-src-list="dynamicTaskImageUrls"
              ></el-image>
            </div>
            <span v-else class="dynamic-detail-photo-empty">暂无图片</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import EZUIKit from "ezuikit-js";
import waterDept from "./assets/popup/waterdept.png";
import spotBGRecordImage from "./assets/popup/记录边框.png";

import waterImg from "./assets/popup/液体.png";
import rectImg from "./assets/popup/方块图标.png";
import AMapLoader from "@amap/amap-jsapi-loader";
import * as echarts from "echarts";
import "echarts-liquidfill";

import DateTimeBox from "./components/DateTimeBox.vue";
import ContentBox from "./components/ContentBox.vue";
import ContentItem from "./components/ContentItem.vue";
import CTContentItem from "./components/CTContentItem.vue";
import dataTotalImage from "./assets/img/datatotal/-h-边框.png";
import dataTotalImage2 from "./assets/img/gas/-h-边框.png";
import dataTotalImage3 from "./assets/img/tasktotal/-h-边框.png";
import dataTotalImage4 from "./assets/img/cttotal/-h-边框.png";
import dataTotalImage5 from "./assets/img/work/-h-边框.png";

import dataTotalSpot from "./assets/img/datatotal/-h-污水井.png";
import deviceTotal from "./assets/img/datatotal/-h-物联网.png";
import xunJian from "./assets/img/datatotal/-h-巡检数量.png";
import exeception from "./assets/img/datatotal/-h-游客.png";
import qingtao from "./assets/img/datatotal/-h-清掏总数.png";
import carbon from "./assets/img/datatotal/-h-碳积分.png";

import yoouhaiqiti from "./assets/img/gas/有害气体.png";
import youhao from "./assets/img/gas/油耗.png";
import jiawan from "./assets/img/gas/甲烷.png";
import liuhuaqing from "./assets/img/gas/硫化氢.png";
import anqi from "./assets/img/gas/氨气.png";
import co2 from "./assets/img/gas/二氧化碳.png";

import totalIcon from "./assets/img/gas/同比图标.png";
import totalIconUp from "./assets/img/gas/上升.png";
import totalIconDown from "./assets/img/gas/下降.png";

import citiTotalGreen from "./assets/img/cttotal/-h-绿色.png";
import citiTotalOrange from "./assets/img/cttotal/-h-橙色.png";
import citiTotalRed from "./assets/img/cttotal/-h-红色.png";
import citiTotalYellow from "./assets/img/cttotal/-h-黄色.png";

import iconOragnge from "./assets/icons/spot_orange.png";
import iconYellow from "./assets/icons/spot_yellow.png";
import iconRed from "./assets/icons/spot_red.png";
import iconGreen from "./assets/icons/spot_green.png"; //-h-定位绿色.png';

import carRed from "./assets/icons/-h-环卫垃圾车-红色.png";
import carYellow from "./assets/icons/-h-环卫垃圾车-黄色.png";
import carGreen from "./assets/icons/-h-环卫垃圾车-绿色.png";

import {
  getQingTaoRecordImages,
  getSumaryData,
  getSpotList,
  getCarList,
  getCarTrack,
  getSpotTypeCount,
  getExceptionList0,
  getExceptionList1,
  getQingTaoRecords,
  getOverviewDetailList,
  getTaskDetailList,
  getResidueDetailList,
  getPoolDetailList,
  getWorkDynamicsList,
  getWorkDynamicTaskDetail,
  getWorkDynamicTaskImages,
  getHistoryQingTaoRecords,
  getCameraUrl,
  getCameraPlayerToken,
} from "../../api/index";
import { wgs84ToGcj02 } from "../../utils/coordTransform";
import { getPermissionInfo, logout } from "../../utils/request";
import { clearAuth, isTokenFromPc } from "../../utils/auth";

// 与 PC 端 userStore.getSystemTitle 的默认值保持一致
const DEFAULT_SYSTEM_TITLE = "智慧清掏作业平台";

import spotBGImage from "./assets/popup/井盖边框.png";
import spotClose from "./assets/popup/关闭.png";
import carBGImage from "./assets/popup/车辆边框.png";
import fullScreen from "./assets/popup/MaterialSymbolsLightFullscreen.svg";
import fullScreenExit from "./assets/popup/MaterialSymbolsLightFullscreenExit.svg";
import closeCameraBtn from "./assets/popup/MaterialSymbolsClose.svg";

export default {
  name: "map-view",
  components: {
    ContentBox,
    ContentItem,
    CTContentItem,
    DateTimeBox,
  },
  mounted() {
    this.loadSystemTitle();
    this.initAMap();
    this.initEchart();
    this.getPageSumaryData();

    // 数据总览/任务总览/池体总览 面板数据：1 分钟自动刷新
    setInterval(() => {
      this.getPageSumaryData();
    }, 60000);

    // 地图点位与车辆 GPS：5 分钟刷新
    setInterval(() => {
      this.getMarkerData(this.AMap);
    }, 300000);

    this.updateDynamicLoop();
  },
  data() {
    return {
      systemTitle: DEFAULT_SYSTEM_TITLE,
      embedded: window.self !== window.top,
      url: "",
      qtImageGroups: [],

      fullScreen,
      fullScreenExit,
      showCamera: false,
      exceptionList: [],
      xunjianList: [],
      qingTaoList: [],
      clickBtn: 1,
      spotBGRecordImage,
      waterDept,
      rectImg,
      waterImg,
      spotBGImage,
      carBGImage,
      spotClose,
      closeCameraBtn,
      weather: {},
      map: null,
      AMap: null,
      dataTotalImage,
      dataTotalImage2,
      dataTotalImage3,
      dataTotalImage4,
      dataTotalImage5,

      iconOragnge,
      iconYellow,
      iconRed,
      iconGreen,

      carRed,
      carYellow,
      carGreen,

      dataTotal: {
        icon: dataTotalSpot,
        num: 0,
        unit: "个",
        desc: "井盖数量",
      },
      deviceTotal: {
        icon: deviceTotal,
        num: 0,
        unit: "个",
        desc: "传感器数量",
      },
      xunJian: {
        icon: xunJian,
        num: 0,
        unit: "个",
        desc: "预警数量",
      },
      exeception: {
        icon: exeception,
        num: 0,
        unit: "次",
        desc: "总清掏数",
      },
      qingtao: {
        icon: qingtao,
        num: 0,
        unit: "家",
        desc: "入档客户数",
      },
      carbon: {
        icon: carbon,
        num: 0,
        unit: "家",
        desc: "签约客户数",
      },
      // 明细行下钻：历史清掏记录列表弹窗
      historyQingTaoDialog: {
        visible: false,
        loading: false,
        title: "",
        list: [],
        keyword: "",
        page: 1,
        pageSize: 10,
      },
      // 数据总览六项明细弹窗
      overviewDialog: {
        visible: false,
        loading: false,
        title: "",
        type: "",
        metric: "",
        businessType: "",
        keyword: "",
        selectValue: "",
        page: 1,
        pageSize: 10,
        list: [],
      },
      dynamicDetailDialog: {
        visible: false,
        loading: false,
        // dynamic=工作动态详情（含事件三字段） task=任务单详情（仅工单+照片）
        mode: "dynamic",
        item: {},
        task: null,
        images: [],
      },
      dynamicDetailRequestSeq: 0,
      // 清掏记录详情来源：true=点位弹窗（关闭时恢复记录列表），false=历史清掏记录弹窗
      qtRecordFromSpot: false,
      yoouhaiqiti: {
        icon: yoouhaiqiti,
        num: 0,
        unit: "ppm",
        desc: "有害气体",
      },
      youhao: {
        icon: youhao,
        num: 0,
        unit: "L",
        desc: "油耗",
      },
      jiawan: {
        icon: jiawan,
        num: 0,
        unit: "ppm",
        desc: "甲烷",
      },
      liuhuaqing: {
        icon: liuhuaqing,
        num: 0,
        unit: "ppm",
        desc: "硫化氢",
      },
      anqi: {
        icon: anqi,
        num: 0,
        unit: "ppm",
        desc: "氨气",
      },
      co2: {
        icon: co2,
        num: 0,
        unit: "ppm",
        desc: "二氧化碳",
      },
      qitiTotal: {
        icon: totalIcon,
        num: 0,
        unit: "ppm",
        desc: "",
        longDesc: "年有害气体总额",
        year: "",
        direction: "",
        directionIcon: totalIconDown,
      },
      youhaoTotal: {
        icon: totalIcon,
        num: 0,
        unit: "L",
        desc: "",
        longDesc: "年车辆油耗总额",
        year: "",
        direction: "",
        directionIcon: totalIconDown,
      },

      citiTotalGreen: {
        icon: citiTotalGreen,
        num: 0,
        unit: "个",
        desc: "化粪池总数",
      },
      citiTotalOrange: {
        icon: citiTotalOrange,
        num: 0,
        unit: "个",
        desc: "故障设备总数",
      },
      citiTotalRed: {
        icon: citiTotalRed,
        num: 0,
        unit: "个",
        desc: "报警设备总数",
      },
      citiTotalYellow: {
        icon: citiTotalYellow,
        num: 0,
        unit: "个",
        desc: "预警池体总数",
      },
      spotTypeCounts: [],
      poolOverviewColors: ["#00ff00", "orange", "yellow", "red"],
      poolOverviewIcons: [citiTotalGreen, citiTotalOrange, citiTotalYellow, citiTotalRed],
      overviewPageSizes: [10, 20, 50],
      taskOverview: [],
      residueAmount: 0,
      spotMarkers: [],
      spotMarkerData: [],
      spotMarkerDataMap: {},

      carMarkers: [],
      carTrackLine: null,
      carMarkerData: [],
      carMarkerDataMap: {},

      workDynamics: [],
      dynamicLoopActive: false,


      clickedSpot: {},
      showClickedSpot: false,
      clickedCar: {},
      clickedQTRecord: {},
      isFullScreen: false,
      camera: undefined, //用于摄像头组件对象
      offline_enable: false, //设备是否在线
      player_div: {
        // 播放器尺寸配置
        height: 0,
        width: 0,
      },
    };
  },
  beforeDestroy() {
    this.map?.destroy();
  },
  watch: {
    // 工作动态数据每分钟刷新，重算是否需要循环滚动
    workDynamics() {
      this.updateDynamicLoop();
    },
  },
  computed: {
    sortedCarMarkerData() {
      return [...this.carMarkerData].sort(
        (first, second) => this.getCarStatusOrder(first) - this.getCarStatusOrder(second)
      );
    },

    // 动态详情弹窗标题：工作动态下钻显示事件详情，任务列表行下钻显示任务单详情
    dynamicDetailTitle() {
      return this.dynamicDetailDialog.mode === "task" ? "任务单详情" : "工作动态详情";
    },
    // 明细列表行是否可点击下钻（工作动态列表无下钻）
    overviewRowClickable() {
      return this.overviewDialog.type !== "workDynamics";
    },
    poolOverviewItems() {
      if (this.spotTypeCounts.length === 0) {
        return [
          this.citiTotalGreen,
          this.citiTotalOrange,
          this.citiTotalYellow,
          this.citiTotalRed,
        ];
      }
      return this.spotTypeCounts.map((item, index) => ({
        ...item,
        icon: this.poolOverviewIcons[index % this.poolOverviewIcons.length],
        num: Number(item.spotCount || 0),
        unit: "个",
        desc: item.spotTypeName || "未命名池体",
      }));
    },
    // 当前弹窗类型的表头列（见 methods.overviewColumnsFor）
    overviewColumns() {
      return this.overviewColumnsFor(
        this.overviewDialog.type,
        this.overviewDialog.metric,
        this.overviewDialog.businessType
      );
    },
    overviewFilterConfig() {
      const configs = {
        cover: {
          searchProps: ["name", "code", "subName"],
          placeholder: "请输入点位名称/点位编号/归属客户",
          selectProp: "typeName",
          selectPlaceholder: "全部池体类型",
        },
        sensor: {
          searchProps: ["name", "subName"],
          placeholder: "请输入点位名称/归属客户",
        },
        alert: {
          searchProps: ["name", "subName"],
          placeholder: "请输入客户名称/告警设施",
          selectProp: "typeName",
          selectPlaceholder: "全部告警项",
        },
        qingtao: {
          searchProps: ["name", "subName"],
          placeholder: "请输入任务号/客户/点位",
        },
        archivedCustomer: {
          searchProps: ["name", "subName"],
          placeholder: "请输入客户名称/联系人",
        },
        contractCustomer: {
          searchProps: ["name", "subName"],
          placeholder: "请输入客户名称/联系人",
        },
        taskOverview: {
          searchProps: ["taskCode", "customerName"],
          placeholder: "请输入任务编号/客户",
          selectProp: this.overviewDialog.metric === "finished" ? "" : "statusName",
          selectPlaceholder: this.overviewDialog.metric === "finished" ? "" : "全部状态",
        },
        residue: {
          searchProps: ["taskCode", "customerName"],
          placeholder: "请输入任务编号/客户",
        },
        poolOverview: {
          searchProps: ["name", "code", "customerName"],
          placeholder: "请输入点位名称/点位编号/客户",
        },
      };
      return configs[this.overviewDialog.type] || {
        searchProps: this.overviewColumns.map((column) => column.prop),
        placeholder: "请输入关键字",
      };
    },
    overviewSelectOptions() {
      const selectProp = this.overviewFilterConfig.selectProp;
      if (!selectProp) return [];

      return Array.from(
        new Set(
          this.overviewDialog.list
            .map((row) => this.overviewFilterValue(row, selectProp))
            .filter((value) => value !== "--" && value !== "")
        )
      );
    },
    overviewFilteredList() {
      const keyword = String(this.overviewDialog.keyword || "").trim().toLowerCase();
      const searchProps = this.overviewFilterConfig.searchProps || [];
      const selectProp = this.overviewFilterConfig.selectProp;
      const selectValue = String(this.overviewDialog.selectValue || "");

      return this.overviewDialog.list.filter((row) => {
        const matchesKeyword =
          !keyword ||
          searchProps.some((prop) =>
            String(this.overviewFilterValue(row, prop)).toLowerCase().includes(keyword)
          );
        const matchesSelect =
          !selectProp || !selectValue || this.overviewFilterValue(row, selectProp) === selectValue;
        return matchesKeyword && matchesSelect;
      });
    },
    overviewTotal() {
      return this.overviewFilteredList.length;
    },
    overviewPagedList() {
      const pageSize = Number(this.overviewDialog.pageSize) || 10;
      const page = Math.max(Number(this.overviewDialog.page) || 1, 1);
      const start = (page - 1) * pageSize;
      return this.overviewFilteredList.slice(start, start + pageSize);
    },

    // 历史清掏记录：按井盖编码/点位名称/任务编号关键字过滤
    historyQingTaoFilteredList() {
      const keyword = String(this.historyQingTaoDialog.keyword || "").trim().toLowerCase();
      if (!keyword) return this.historyQingTaoDialog.list;
      return this.historyQingTaoDialog.list.filter((item) =>
        ["qrCode", "name", "code"].some((prop) =>
          String(item[prop] || "").toLowerCase().includes(keyword)
        )
      );
    },
    historyQingTaoTotal() {
      return this.historyQingTaoFilteredList.length;
    },
    historyQingTaoPagedList() {
      const pageSize = Number(this.historyQingTaoDialog.pageSize) || 10;
      const page = Math.max(Number(this.historyQingTaoDialog.page) || 1, 1);
      const start = (page - 1) * pageSize;
      return this.historyQingTaoFilteredList.slice(start, start + pageSize);
    },
    dynamicTaskAddress() {
      const task = this.dynamicDetailDialog.task || {};
      return task.spotAddress || task.address || task.spotName || "--";
    },
    dynamicTaskPeople() {
      const task = this.dynamicDetailDialog.task || {};
      const names = task.executeUserNames || task.executeUsers;
      return task.executeUser || (Array.isArray(names) ? names.join("、") : names) || "--";
    },
    dynamicTaskCars() {
      const task = this.dynamicDetailDialog.task || {};
      const cars = task.executeCarNos || task.executeCars;
      return task.executeCar || (Array.isArray(cars) ? cars.join("、") : cars) || "--";
    },
    dynamicTaskType() {
      const task = this.dynamicDetailDialog.task || {};
      const businessNames = {
        septic: "化粪池清掏",
        dredging: "管道疏通",
        survey: "管道勘测",
      };
      return task.taskTypeName || businessNames[this.dynamicDetailDialog.item.businessType] || "--";
    },
    dynamicTaskContact() {
      const task = this.dynamicDetailDialog.task || {};
      return task.contactUser || task.enterpriseContactUser || task.siteContactUser || "--";
    },
    dynamicTaskPhone() {
      const task = this.dynamicDetailDialog.task || {};
      return task.contactPhone || task.enterpriseContactPhone || task.siteContactPhone || "--";
    },
    dynamicTaskStatus() {
      return this.taskStatusName({
        ...(this.dynamicDetailDialog.task || {}),
        businessType: this.dynamicDetailDialog.item.businessType,
      });
    },
    dynamicTaskTime() {
      const task = this.dynamicDetailDialog.task || {};
      return this.overviewCellValue(task, task.surveyTime ? "surveyTime" : "executeTime");
    },
    dynamicTaskContent() {
      const task = this.dynamicDetailDialog.task || {};
      return task.surveyContent || task.constructionRequirement || "--";
    },
    dynamicTaskFinishTime() {
      const task = this.dynamicDetailDialog.task || {};
      const value = task.finishTime || task.endTime || task.receiptTime;
      return value ? this.formatDateTimeValue(value) : "--";
    },
    // 施工照片分组：四种类型固定展示，无 imageType 的历史照片归入施工后（与 PC/移动端口径一致）
    dynamicTaskImageGroups() {
      const defs = [
        { type: "before", label: "施工前" },
        { type: "during", label: "施工中" },
        { type: "after", label: "施工后" },
        { type: "acceptance", label: "验收单" },
      ];
      const images = this.dynamicDetailDialog.images || [];
      return defs.map((d) => ({
        ...d,
        urls: images
          .filter((img) => (img.imageType || "after") === d.type)
          .map((img) => img.url),
      }));
    },
    // 有关联工单即展示施工照片区块，无图的类型显示“暂无图片”
    dynamicHasTaskImages() {
      const item = this.dynamicDetailDialog.item || {};
      return Boolean(item.taskId && item.businessType);
    },
    dynamicTaskImageUrls() {
      return this.dynamicTaskImageGroups.reduce((all, g) => all.concat(g.urls), []);
    },
    showTasks() {
      return this.taskDynamics.slice(this.startIndex, this.endIndex);
    },
  },

  methods: {
    // 顶部标题：与 PC 端一致，取租户「平台标题」，未配置时用默认标题
    async loadSystemTitle() {
      try {
        const res = await getPermissionInfo();
        const data = res && res.data && res.data.code === 0 ? res.data.data : null;
        const title = data && data.systemTitle ? data.systemTitle.trim() : "";
        this.systemTitle = title || DEFAULT_SYSTEM_TITLE;
      } catch (e) {
        this.systemTitle = DEFAULT_SYSTEM_TITLE;
      }
      document.title = this.systemTitle;
    },
    handleLogout() {
      this.$confirm("确定退出登录吗？", "提示", {
        confirmButtonText: "退出",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // PC 菜单交接来的令牌与 PC 端共用，只清本地，不注销服务端令牌，避免把 PC 端一起踢下线
          if (!isTokenFromPc()) {
            try {
              await logout();
            } catch (e) {
              // 注销失败不影响本地退出
            }
          }
          clearAuth();
          this.$router.replace("/login");
        })
        .catch(() => {});
    },
    // =================== 数据总览六项明细弹窗 ===================
    // 每种类型的表头配置：prop 对应后端 OverviewItemVO 字段
    overviewColumnsFor(type, metric, businessType) {
      const taskColumns = {
        dispatched: [
          { prop: "taskCode", label: "任务编号", width: "18%" },
          { prop: "customerName", label: "客户", width: "20%" },
          { prop: "location", label: "作业位置", width: "24%" },
          { prop: "executeUser", label: "作业人员", width: "14%" },
          { prop: "executeCar", label: "作业车辆", width: "12%" },
          { prop: "statusName", label: "状态", width: "12%" },
        ],
        inTransit: [
          { prop: "taskCode", label: "任务编号", width: "18%" },
          { prop: "customerName", label: "客户", width: "20%" },
          { prop: "location", label: "作业位置", width: "24%" },
          { prop: "executeUser", label: "作业人员", width: "14%" },
          { prop: "executeCar", label: "作业车辆", width: "12%" },
          { prop: "plannedTime", label: "计划时间", width: "12%" },
        ],
        finished: [
          { prop: "taskCode", label: "任务编号", width: "18%" },
          { prop: "customerName", label: "客户", width: "20%" },
          { prop: "location", label: "作业位置", width: "24%" },
          { prop: "executeUser", label: "作业人员", width: "14%" },
          { prop: "executeCar", label: "作业车辆", width: "12%" },
          { prop: "finishTime", label: "完成时间", width: "12%" },
        ],
      };
      if (metric === "inTransit") {
        taskColumns.inTransit.splice(5, 0, {
          prop: "statusName",
          label: "\u72b6\u6001",
          width: "12%",
        });
      }
      const map = {
        cover: [
          { prop: "name", label: "点位名称", width: "26%" },
          { prop: "code", label: "点位编号", width: "20%" },
          { prop: "subName", label: "归属客户", width: "24%" },
          { prop: "typeName", label: "池体类型", width: "14%" },
          { prop: "extra", label: "位置", width: "16%" },
        ],
        sensor: [
          { prop: "name", label: "点位名称", width: "24%" },
          { prop: "code", label: "设备编号", width: "20%" },
          { prop: "typeName", label: "设备名称", width: "18%" },
          { prop: "subName", label: "归属客户", width: "22%" },
          { prop: "extra", label: "位置", width: "16%" },
        ],
        alert: [
          { prop: "name", label: "客户名称", width: "24%" },
          { prop: "subName", label: "告警设施", width: "22%" },
          { prop: "typeName", label: "告警项", width: "18%" },
          { prop: "extra", label: "指标值", width: "16%" },
          { prop: "timeValue", label: "告警时间", width: "20%" },
        ],
        qingtao: [
          { prop: "name", label: "任务号", width: "18%" },
          { prop: "subName", label: "客户/点位", width: "28%" },
          { prop: "typeName", label: "作业车辆", width: "18%" },
          { prop: "extra", label: "作业人员", width: "16%" },
          { prop: "timeValue", label: "完成时间", width: "20%" },
        ],
        archivedCustomer: [
          { prop: "name", label: "客户名称", width: "30%" },
          { prop: "subName", label: "联系人", width: "16%" },
          { prop: "extra2", label: "联系电话", width: "22%" },
          { prop: "countValue", label: "点位数", width: "14%" },
        ],
        contractCustomer: [
          { prop: "name", label: "客户名称", width: "30%" },
          { prop: "subName", label: "联系人", width: "16%" },
          { prop: "extra2", label: "联系电话", width: "22%" },
          { prop: "timeValue", label: "签约方式", width: "18%" },
        ],
        residue: [
          { prop: "taskCode", label: "任务编号", width: "18%" },
          { prop: "customerName", label: "客户", width: "22%" },
          { prop: "originAddress", label: "来源位置", width: "28%" },
          { prop: "carNo", label: "车辆", width: "12%" },
          { prop: "loadingAmount", label: "废渣(袋)", width: "10%" },
          { prop: "stationTime", label: "入站时间", width: "10%" },
        ],
        poolOverview: [
          { prop: "name", label: "点位名称", width: "22%" },
          { prop: "code", label: "点位编号", width: "18%" },
          { prop: "customerName", label: "客户", width: "24%" },
          { prop: "address", label: "位置", width: "24%" },
          { prop: "spotTypeName", label: "池体类型", width: "12%" },
        ],
        workDynamics: [
          { prop: "eventType", label: "事件类型", width: "18%" },
          { prop: "eventDesc", label: "事件描述", width: "57%" },
          { prop: "eventTime", label: "发生时间", width: "25%" },
        ],
      };
      if (type === "taskOverview") {
        const columns = taskColumns[metric] || taskColumns.dispatched;
        if (businessType === "dredging" || businessType === "survey") {
          const pipeColumns = columns.filter((column) => column.prop !== "location");
          const widths =
            metric === "inTransit"
              ? ["18%", "26%", "15%", "15%", "12%", "14%"]
              : ["22%", "30%", "18%", "16%", "14%"];
          return pipeColumns.map((column, index) => ({ ...column, width: widths[index] }));
        }
        if (metric === "inTransit") {
          const widths = ["14%", "18%", "22%", "12%", "10%", "12%", "12%"];
          return columns.map((column, index) => ({ ...column, width: widths[index] }));
        }
        return columns;
      }
      return map[type] || [];
    },

    openDashboardList(type, title, load, metric = "", businessType = "") {
      if (!load) return;

      this.overviewDialog.type = type;
      this.overviewDialog.title = title;
      this.overviewDialog.metric = metric;
      this.overviewDialog.businessType = businessType;
      this.overviewDialog.keyword = "";
      this.overviewDialog.selectValue = "";
      this.overviewDialog.page = 1;
      this.overviewDialog.visible = true;
      this.overviewDialog.loading = true;
      this.overviewDialog.list = [];
      load()
        .then((res) => {
          this.overviewDialog.list =
            res.status === 200 && res.data.code === 0 && Array.isArray(res.data.data)
              ? res.data.data
              : [];
          this.overviewDialog.loading = false;
        })
        .catch(() => {
          this.overviewDialog.list = [];
          this.overviewDialog.loading = false;
        });
    },

    openTaskDetail(biz, metric) {
      const labels = { dispatched: "派单", inTransit: "在途", finished: "完成" };
      this.openDashboardList(
        "taskOverview",
        `${biz.name} ${labels[metric] || ""}明细`,
        () => getTaskDetailList(biz.type, metric),
        metric,
        biz.type
      );
    },

    openResidueDetail() {
      this.openDashboardList("residue", "化粪池业务 废渣来源明细", getResidueDetailList);
    },

    async openWorkDynamicsDetail(item) {
      if (item) {
        await this.loadDynamicDetail(item, "dynamic");
        return;
      }
      this.openDashboardList("workDynamics", "工作动态明细", getWorkDynamicsList);
    },

    // 任务明细列表行下钻：直接查看该任务单详情（化粪池/疏通/勘测/废渣来源共用）
    async openTaskOrderDetail(businessType, taskId) {
      if (!businessType || !taskId) return;
      await this.loadDynamicDetail({ businessType, taskId }, "task");
    },

    // 工单详情弹窗共享加载：dynamic=工作动态（事件+工单），task=仅工单+施工照片
    async loadDynamicDetail(item, mode) {
      const requestSeq = ++this.dynamicDetailRequestSeq;
      this.dynamicDetailDialog.mode = mode;
      this.dynamicDetailDialog.item = item;
      this.dynamicDetailDialog.task = null;
      this.dynamicDetailDialog.images = [];
      this.dynamicDetailDialog.visible = true;
      this.dynamicDetailDialog.loading = Boolean(item.taskId && item.businessType);
      if (this.dynamicDetailDialog.loading) {
        const taskPromise = getWorkDynamicTaskDetail(item.businessType, item.taskId)
          .then((res) => {
            if (
              requestSeq === this.dynamicDetailRequestSeq &&
              res &&
              res.status === 200 &&
              res.data &&
              res.data.code === 0
            ) {
              this.dynamicDetailDialog.task = res.data.data;
            }
          })
          .catch(() => {
            // 任务详情不可用时仍保留动态事件本身
          });
        const imagesPromise = getWorkDynamicTaskImages(item.businessType, item.taskId)
          .then((res) => {
            if (
              requestSeq === this.dynamicDetailRequestSeq &&
              res &&
              res.status === 200 &&
              res.data &&
              res.data.code === 0 &&
              Array.isArray(res.data.data)
            ) {
              this.dynamicDetailDialog.images = res.data.data.filter((img) => img && img.url);
            }
          })
          .catch(() => {
            // 施工照片不可用时不展示照片区块
          });
        await Promise.all([taskPromise, imagesPromise]);
        if (requestSeq === this.dynamicDetailRequestSeq) {
          this.dynamicDetailDialog.loading = false;
        }
      }
    },

    closeWorkDynamicsDetail() {
      this.dynamicDetailRequestSeq += 1;
      this.dynamicDetailDialog.visible = false;
      this.dynamicDetailDialog.loading = false;
      this.dynamicDetailDialog.mode = "dynamic";
      this.dynamicDetailDialog.item = {};
      this.dynamicDetailDialog.task = null;
      this.dynamicDetailDialog.images = [];
    },

    // 明细列表行点击下钻：三类业务/废渣行→任务单详情，其余行→历史清掏记录
    handleOverviewRowClick(row) {
      if (!row) return;
      if (this.overviewDialog.type === "taskOverview") {
        this.openTaskOrderDetail(this.overviewDialog.businessType, row.id);
        return;
      }
      if (this.overviewDialog.type === "residue") {
        this.openTaskOrderDetail("septic", row.taskId);
        return;
      }
      this.openHistoryQingTao(row);
    },

    // 其他明细行下钻：按行 id 查该点位/客户/任务的历史清掏记录
    openHistoryQingTao(row) {
      const sourceTypeMap = {
        cover: "spot",
        sensor: "spot",
        poolOverview: "spot",
        alert: "spot",
        qingtao: "task",
        archivedCustomer: "enterprise",
        contractCustomer: "enterprise",
      };
      const sourceType = sourceTypeMap[this.overviewDialog.type];
      // 预警行的可下钻点位在 refId（仅井盖点设施有值，管道点无清掏记录不下钻）
      const sourceId = this.overviewDialog.type === "alert" ? row.refId : row.id;
      if (!sourceType || !sourceId) return;

      this.historyQingTaoDialog.title =
        (row.name || "点位") + " 历史清掏记录";
      this.historyQingTaoDialog.keyword = "";
      this.historyQingTaoDialog.page = 1;
      this.historyQingTaoDialog.visible = true;
      this.historyQingTaoDialog.loading = true;
      this.historyQingTaoDialog.list = [];
      getHistoryQingTaoRecords(sourceType, sourceId)
        .then((res) => {
          this.historyQingTaoDialog.list =
            res.status === 200 && res.data.code === 0 && Array.isArray(res.data.data)
              ? res.data.data
              : [];
          this.historyQingTaoDialog.loading = false;
        })
        .catch(() => {
          this.historyQingTaoDialog.list = [];
          this.historyQingTaoDialog.loading = false;
        });
    },

    closeHistoryQingTao() {
      this.historyQingTaoDialog.visible = false;
      this.historyQingTaoDialog.loading = false;
      this.historyQingTaoDialog.list = [];
      this.historyQingTaoDialog.keyword = "";
      this.historyQingTaoDialog.page = 1;
    },

    handleHistorySearch() {
      this.historyQingTaoDialog.page = 1;
    },

    handleHistoryPageSizeChange(size) {
      this.historyQingTaoDialog.pageSize = Number(size) || 10;
      this.historyQingTaoDialog.page = 1;
    },

    handleHistoryPageChange(page) {
      this.historyQingTaoDialog.page = Number(page) || 1;
    },

    openPoolDetail(item) {
      if (!item || item.spotTypeId === null || item.spotTypeId === undefined) return;
      this.openDashboardList(
        "poolOverview",
        `${item.desc || "池体"} 来源明细`,
        () => getPoolDetailList(item.spotTypeId)
      );
    },

    overviewFilterValue(row, prop) {
      if (prop === "statusName") return this.taskStatusName(row);
      return String(this.overviewCellValue(row, prop));
    },

    overviewCellValue(row, prop) {
      const value = row && row[prop];
      if (prop === "statusName") {
        return this.taskStatusName(row);
      }
      if (value === null || value === undefined || value === "") return "--";
      if (prop === "eventType") {
        return {
          RECEIVE: "处置接收",
          TRANSPORT: "运输中",
          COMPLETE: "作业完成",
          DISPATCH: "工单派单",
          ARRIVE: "车辆抵达",
        }[value] || value;
      }
      if (["eventTime", "plannedTime", "surveyTime", "executeTime", "allocationTime", "startTime", "endTime", "finishTime", "stationTime"].includes(prop)) {
        return this.formatDateTimeValue(value);
      }
      return value;
    },

    dynamicTaskValue(prop) {
      const value = this.dynamicDetailDialog.task && this.dynamicDetailDialog.task[prop];
      if (value === null || value === undefined || value === "") return "--";
      if (["plannedTime", "surveyTime", "executeTime", "allocationTime", "startTime", "endTime", "finishTime", "receiptTime"].includes(prop)) {
        return this.formatDateTimeValue(value);
      }
      return String(value);
    },

    taskStatusName(row) {
      const status = Number(row && row.status);
      const businessType = (row && (row.businessType || row.business_type)) || this.overviewDialog.businessType;
      const statusNames = {
        septic: {
          0: "\u5f85\u5206\u914d",
          1: "\u5f85\u51fa\u52e4",
          2: "\u4f5c\u4e1a\u4e2d",
          3: "\u8fd0\u8f93\u4e2d",
          4: "\u5df2\u5b8c\u6210",
          5: "\u5df2\u5173\u95ed",
        },
        dredging: {
          0: "\u5f85\u5206\u914d",
          2: "\u4f5c\u4e1a\u4e2d",
          3: "\u8fd0\u8f93\u4e2d",
          4: "\u5df2\u5b8c\u6210",
          5: "\u5df2\u5173\u95ed",
        },
        survey: {
          0: "\u5f85\u5206\u914d",
          1: "\u5f85\u52d8\u6d4b",
          2: "\u52d8\u6d4b\u4e2d",
          3: "\u5df2\u52d8\u6d4b",
          4: "\u5df2\u5b8c\u6210",
        },
      };
      return (statusNames[businessType] && statusNames[businessType][status]) || (row && row.statusName) || "--";
    },

    formatDateTimeValue(value) {
      if (value === 0 || value === "0") return "--";
      if (Array.isArray(value)) {
        const parts = value.slice(0, 6).map((part, index) =>
          String(Number(part) || 0).padStart(index === 0 ? 4 : 2, "0")
        );
        if (parts.length >= 3) {
          return `${parts[0]}-${parts[1]}-${parts[2]} ${parts[3] || "00"}:${parts[4] || "00"}:${parts[5] || "00"}`;
        }
      }
      if (typeof value === "number" || /^\d{10,13}$/.test(String(value))) {
        const numeric = Number(value);
        if (numeric <= 0) return "--";
        const date = new Date(numeric < 100000000000 ? numeric * 1000 : numeric);
        if (!Number.isNaN(date.getTime())) {
          const pad = (part) => String(part).padStart(2, "0");
          return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
            date.getHours()
          )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
        }
      }
      const formatted = String(value).replace("T", " ").replace(/\.\d{3,6}$/, "");
      return /^1970-01-01(?: 00:00:00)?$/.test(formatted) ? "--" : formatted;
    },

    handleOverviewSearch() {
      this.overviewDialog.page = 1;
    },

    handleOverviewPageSizeChange(size) {
      this.overviewDialog.pageSize = Number(size) || 10;
      this.overviewDialog.page = 1;
    },

    handleOverviewPageChange(page) {
      this.overviewDialog.page = Number(page) || 1;
    },

    openOverviewList(type, item) {
      this.overviewDialog.type = type;
      this.overviewDialog.metric = "";
      this.overviewDialog.businessType = "";
      this.overviewDialog.keyword = "";
      this.overviewDialog.selectValue = "";
      this.overviewDialog.page = 1;
      this.overviewDialog.title = item && item.desc ? item.desc + "明细" : "数据总览明细";
      this.overviewDialog.visible = true;
      this.overviewDialog.loading = true;
      this.overviewDialog.list = [];
      getOverviewDetailList(type)
        .then((res) => {
          // 与 getSpotTypeCount 用法一致：axios 原始响应，CommonResult 解包取 res.data.data
          this.overviewDialog.list =
            res.status === 200 && res.data.code === 0 && Array.isArray(res.data.data)
              ? res.data.data
              : [];
          this.overviewDialog.loading = false;
        })
        .catch(() => {
          this.overviewDialog.list = [];
          this.overviewDialog.loading = false;
        });
    },

    closeOverviewList() {
      this.overviewDialog.visible = false;
    },
    // 工作动态事件颜色：处置接收-金 运输中-青 完成-蓝 派单-绿 抵达-橙
    eventColor(type) {
      const colors = {
        RECEIVE: "#f5d76e",
        TRANSPORT: "#35e0d0",
        COMPLETE: "#37a6ff",
        DISPATCH: "#35e08c",
        ARRIVE: "#ff9d4d",
      };
      return colors[type] || "#37a6ff";
    },
    // 相对时间：x分钟前 / x小时前 / 昨天 / 日期
    formatRelativeTime(time) {
      if (time == null || time === "") return "";
      // 后端可能返回 epoch 毫秒数或 "yyyy-MM-dd HH:mm:ss" 字符串
      const d = typeof time === "number" ? new Date(time) : new Date(time.replace(/-/g, "/"));
      if (isNaN(d.getTime())) return String(time);
      const diff = Date.now() - d.getTime();
      const minute = 60 * 1000;
      if (diff < minute) return "刚刚";
      if (diff < 60 * minute) return Math.floor(diff / minute) + " 分钟前";
      if (diff < 24 * 60 * minute) return Math.floor(diff / (60 * minute)) + " 小时前";
      if (diff < 48 * 60 * minute) return "昨天";
      const m = d.getMonth() + 1, day = d.getDate();
      return (d.getFullYear() !== new Date().getFullYear() ? d.getFullYear() + "-" : "")
          + (m < 10 ? "0" + m : m) + "-" + (day < 10 ? "0" + day : day);
    },
    // 工作动态无缝循环：内容超出面板高度才启动滚动动画
    updateDynamicLoop() {
      this.$nextTick(() => {
        const wrap = this.$refs.dynamicScroll;
        const loop = this.$refs.dynamicLoop;
        const half = loop && loop.children[0] ? loop.children[0].offsetHeight : 0;
        this.dynamicLoopActive = !!wrap && half > wrap.clientHeight;
      });
    },
    async playCamera() {
      this.showCamera = true;
      this.isFullScreen = false;
      if (this.clickedCar.cameraDeviceSerial) {
        let res = await getCameraPlayerToken();
        console.log(res);
        let accessToken = undefined;
        if (res.status === 200 && res.data.code === 0) {
          accessToken = res.data.data;
        }
        if (accessToken) {
          res = await getCameraUrl(
            accessToken,
            this.clickedCar.cameraDeviceSerial
          );
          console.log(res);
          if (res.status === 200 && res.data.code === "200") {
            const url = res.data.data.url;
            this.showCamera = true;
            this.addvideo(accessToken, url);
            this.offline_enable = false;
          } else {
            console.log(res.data.msg);
            this.$message.error(res.data.msg);
            this.offline_enable = true;
          }
        }
      }
    },
    addvideo(accessToken, url) {
      console.log(accessToken);

      if (this.player_div.height == 0 || this.player_div.width) {
        var controlDom = this.$refs.viewtools.getBoundingClientRect();

        this.player_div.height = controlDom.width - 18;
        this.player_div.width = controlDom.height - 20;
      }

      //
      // console.log(controlDom.height);
      // 获取父节点的宽高
      // let divW = this.$refs.viewtools.value.clientWidth;
      // let divH = this.$refs.viewtools.value.clientHeight;

      // console.log(controlDom);
      // let divW = controlDom.width - 18;
      // let divH = controlDom.height - 20;

      // console.log("divW=", divW);
      // console.log("divH=", divH);

      //首次初始化
      if (!this.camera) {
        //获取萤石token
        this.camera = new EZUIKit.EZUIKitPlayer({
          autoplay: true, // 默认播放
          //视频播放包裹元素
          id: "video-container",
          //萤石token
          accessToken: accessToken,
          // ezopen://open.ys7.com/${设备序列号}/{通道号}.live
          url: url, // 播放地址
          template: "pcLive", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；pcLive
          // header: ['capturePicture', 'zoom'], // 如果templete参数不为simple,该字段将被覆盖
          // plugin: ["talk"], // 加载插件，talk-对讲
          useHardDev: true, // 高性能模式
          // 视频下方底部控件
          // footer: ["talk", "broadcast", "hd", "fullScreen"], // 如果template参数不为simple,该字段将被覆盖
          // footer: ['talk', 'hd', 'fullScreen'], // 如果template参数不为simple,该字段将被覆盖
          audio: 0, // 是否默认开启声音 0 - 关闭 1 - 开启

          setWaterMarkFont: null,
          width: this.player_div.width,
          height: this.player_div.height,
        });
      } else {
        this.camera.stop();
        //不用再做初始化，直接加载新请求
        this.camera.play({
          url: url,
          accessToken: accessToken,
        });
      }

      console.log(document.getElementById("video-container-headControl"));
    },
    loadRecordList(seq) {
      this.clickBtn = seq;
    },
    closeSpotPopup() {
      this.clickedSpot = {};
      this.showClickedSpot = false;
    },
    closeCarPopup() {
      this.clickedCar = {};
      this.camera?.stop(); //关闭摄像头播放器（未打开过摄像头时 camera 为 undefined）
      this.showCamera = false;
    },
    closeQTPopup() {
      this.clickedQTRecord = {};
      // 仅点位弹窗进入时恢复其记录列表；从历史清掏记录弹窗进入时回到该弹窗
      this.showClickedSpot = this.qtRecordFromSpot;
    },
    clickQTRow(data) {
      this.showClickedSpot = false;
      this.showQTRecordDetail(data, true);
    },
    // 清掏记录详情共享加载：fromSpot=点位弹窗进入，否则为明细下钻的历史清掏记录弹窗进入
    showQTRecordDetail(data, fromSpot) {
      this.qtRecordFromSpot = fromSpot;
      this.clickedQTRecord = data;

      this.url = "";
      //施工图片按 施工前/施工中/施工后/验收 分组展示
      this.qtImageGroups = [
        { type: "before", label: "施工前", urls: [] },
        { type: "during", label: "施工中", urls: [] },
        { type: "after", label: "施工后", urls: [] },
        { type: "acceptance", label: "验收", urls: [] },
      ];
      getQingTaoRecordImages(data.id).then((res) => {
        if (res.data && res.data.data) {
          res.data.data.forEach((image) => {
            //历史照片无 imageType，按小程序端约定归入施工后
            const group = this.qtImageGroups.find(
              (g) => g.type === image.imageType
            );
            if (image.url) {
              (group || this.qtImageGroups[2]).urls.push(image.url);
            }
          });
        }
      });
    },
    closeCameraPopup() {
      if (this.camera) {
        this.camera.stop();
      }
      this.showCamera = false;
    },
    initEchart() {

      const waterPie = echarts.init(document.getElementById("waterPie"));

      var option = {
        series: [
          {
            type: "liquidFill",
            data: [0.6, 0.5],
            color: ["rgb(0, 108, 253)", "rgb(11, 48, 173)"],
            outline: {
              show: false,
            },
            label: false,
            backgroundStyle: {
              color: "transparent",
            },
          },
        ],
      };
      waterPie.setOption(option);
    },
    initAMap() {
      const that = this;
      window._AMapSecurityConfig = {
        securityJsCode: "fca786ebcf2ffaf830874322ab365891",
      };
      AMapLoader.load({
        key: "9909d9d97b12438e8ff20d9e89bf3984", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale,AMap.Weather"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
      })
        .then((AMap) => {
          this.AMap = AMap;
          this.map = new AMap.Map("container", {
            resizeEnable: false,
            pitch: 30,
            // 设置地图容器id
            viewMode: "3D", // 是否为3D地图模式
            zoom: 18, // 初始化地图级别
            center: [115.93286, 29.70223], // 初始化地图中心点位置
          });
          const styleName = "amap://styles/grey";
          this.map.setMapStyle(styleName);

          //执行实时天气信息查询
          const weather = new AMap.Weather();
          that.getWeather(weather);
          setInterval(() => {
            that.getWeather(weather);
          }, 60000);

          this.getMarkerData(this.AMap);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getWeather(weather) {
      const that = this;
      weather.getLive("九江市", function (err, data) {
        //console.log(err, data);
        that.weather = data;
      });
    },
    async getPageSumaryData() {

      const res = await getSumaryData();
      if (res.status === 200 && res.data.code === 0) {
        console.log(res.data.data);
        const { data } = res.data;

        //数据总览
        this.dataTotal.num = data.coverCount;
        const spotTypeRes = await getSpotTypeCount();
        if (spotTypeRes.status === 200 && spotTypeRes.data.code === 0) {
          const spotTypeCounts = Array.isArray(spotTypeRes.data.data)
            ? spotTypeRes.data.data
            : [];
          this.spotTypeCounts = spotTypeCounts;
          this.dataTotal.num = spotTypeCounts.reduce(
            (total, item) => total + Number(item.spotCount || 0),
            0
          );
        } else {
          this.dataTotal.num = data.sewageWellCount;
        }
        if (this.dataTotal.num >= 10000) {
          this.dataTotal.num = this.dataTotal.num / 10000;
          this.dataTotal.unit = "万个";
        } else {
          this.dataTotal.unit = "个";
        }

        this.deviceTotal.num = data.sensorCount;
        if (this.deviceTotal.num >= 10000) {
          this.deviceTotal.num = this.deviceTotal.num / 10000;
          this.deviceTotal.unit = "万个";
        } else {
          this.deviceTotal.unit = "个";
        }

        this.xunJian.num = data.alertCount;
        if (this.xunJian.num >= 10000) {
          this.xunJian.num = this.xunJian.num / 10000;
          this.xunJian.unit = "万个";
        } else {
          this.xunJian.unit = "个";
        }

        this.exeception.num = data.qingtaoCount;
        if (this.exeception.num >= 10000) {
          this.exeception.num = this.exeception.num / 10000;
          this.exeception.unit = "万次";
        } else {
          this.exeception.unit = "次";
        }

        this.qingtao.num = data.archivedCustomerCount;
        if (this.qingtao.num >= 10000) {
          this.qingtao.num = this.qingtao.num / 10000;
          this.qingtao.unit = "万家";
        } else {
          this.qingtao.unit = "家";
        }

        this.carbon.num = data.contractCustomerCount;
        if (this.carbon.num >= 10000) {
          this.carbon.num = this.carbon.num / 10000;
          this.carbon.unit = "万家";
        } else {
          this.carbon.unit = "家";
        }

        //气体总数
        this.yoouhaiqiti.num = data.harmfulGasLevel;
        this.youhao.num = data.fuelConsumption;
        this.jiawan.num = data.methaneLevel;
        this.liuhuaqing.num = data.hydrogenSulfideLevel;
        this.anqi.num = data.ammoniaLevel;
        this.co2.num = data.carbonDioxideLevel;

        this.qitiTotal.num = data.thisYearYouhaiqiti;
        this.qitiTotal.ratio = data.yearOnYearGrowthCarbonCredit;
        this.qitiTotal.year = data.year;
        if (data.carbonCreditUpOrDown) {
          this.qitiTotal.directionIcon = totalIconUp;
          this.qitiTotal.desc = "上升" + this.qitiTotal.ratio + "%";
        } else {
          this.qitiTotal.directionIcon = totalIconDown;
          this.qitiTotal.desc = "下降" + this.qitiTotal.ratio + "%";
        }
        this.youhaoTotal.num = data.thisYearYouhao;
        this.youhaoTotal.ratio = data.yearOnYearDeclineTrendfuelConsumption;
        this.youhaoTotal.year = data.year;
        if (data.youhaoUpOrDown) {
          this.youhaoTotal.directionIcon = totalIconUp;
          this.youhaoTotal.desc = "上升" + this.youhaoTotal.ratio + "%";
        } else {
          this.youhaoTotal.directionIcon = totalIconDown;
          this.youhaoTotal.desc = "下降" + this.youhaoTotal.ratio + "%";
        }
        const { workDynamics, taskOverview } = data;
        if (workDynamics != null) {
          this.workDynamics = workDynamics;
        }
        if (taskOverview != null) {
          this.taskOverview = taskOverview.businesses || [];
          this.residueAmount = taskOverview.residueAmount ?? 0;
        }
        //池体总览
        this.citiTotalGreen.num = data.septicTankTotalCount;
        this.citiTotalOrange.num = data.faultyDeviceCount;
        this.citiTotalYellow.num = data.warningPoolCount;
        this.citiTotalRed.num = data.alarmDeviceCount;

      }
    },
    async getMarkerData(AMap) {
      this.map.remove(this.spotMarkers);
      this.map.remove(this.carMarkers);
      if (this.carTrackLine) {
        this.map.remove(this.carTrackLine);
        this.carTrackLine = null;
      }

      this.spotMarkerData = [];

      const res = await getSpotList();
      console.log(res.data.data);
      if (res.status === 200 && res.data.code === 0) {
        const { data } = res.data;
        if (data !== null) {
          this.spotMarkerData = data.map((m) => {
            if (m.status === 0) {
              m.icon = iconGreen;
            } else if (m.status === 1) {
              m.icon = iconYellow;
            } else if (m.status === 2) {
              m.icon = iconOragnge;
            } else if (m.status === 3) {
              m.icon = iconRed;
            } else {
              m.icon = iconGreen;
            }
            this.spotMarkerDataMap["" + m.id + ""] = m;
            return m;
          });
        }
      }

      this.spotMarkerData.forEach((m) => {
        // 库存 WGS84 → 高德 GCJ02 后再落点
        const [gLng, gLat] = wgs84ToGcj02(Number(m.lng), Number(m.lat));
        const marker = new AMap.Marker({
          position: new AMap.LngLat(gLng, gLat), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          title: m.name,
          icon: m.icon,
          offset: new AMap.Pixel(-48 / 2, -64),
          extData: m.id,
        });
        marker.setMap(this.map);
        marker.on("click", this.clickSpotMarker);
        if (m.status > 0) {
          marker.dom.classList.add("abnormal_marker");
        }

        this.spotMarkers.push(marker);
      });

      const carRes = await getCarList();
      console.log("carRes", carRes);
      if (carRes.status === 200 && carRes.data.code === 0) {
        const { data } = carRes.data;
        if (data !== null) {
          this.carMarkerData = data.map((m) => {
            // 车辆 GPS 为 WGS84，统一转 GCJ02 供地图落点/居中/逆地理使用；空值保留由 hasGpsLocation 过滤
            const hasRaw = (v) => v !== null && v !== undefined && String(v).trim() !== "" && Number.isFinite(Number(v));
            const [gLng, gLat] = hasRaw(m.lng) && hasRaw(m.lat)
              ? wgs84ToGcj02(Number(m.lng), Number(m.lat))
              : [m.lng, m.lat];
            const car = {
              ...m,
              carId: m.id,
              carContactUser: m.contactUser,
              carContactPhone: m.contactPhone,
              gpsLng: gLng,
              gpsLat: gLat,
              gpsSpeed: m.speed,
              gpsOnlineStatus: m.online ? 1 : 0,
              cameraDeviceSerial: m.cameraDeviceSerial,
            };
            const statusMeta = this.getCarStatusMeta(car);
            car.statuStr = statusMeta.label;
            car.icon = statusMeta.icon;
            this.carMarkerDataMap["" + car.id + ""] = car;
            car.address = "";
            return car;
          });
        }
      }

      // Keep unbound cars in the list, but only create map markers for valid GPS coordinates.
      this.carMarkerData.filter((car) => this.hasGpsLocation(car)).forEach((m) => {
        const marker = new AMap.Marker({
          position: new AMap.LngLat(m.gpsLng, m.gpsLat), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          title: `${m.carTypeName}(${m.carNo})`,
          icon: m.icon,
          offset: new AMap.Pixel(-68 / 2, -85),
          extData: m,
        });
        marker.setMap(this.map);
        marker.on("click", this.clickCarMarker);
        if (m.status > 1) {
          marker.dom.classList.add("abnormal_marker");
        }

        this.carMarkers.push(marker);
      });

      this.map.setFitView();
    },
    getCarStatusMeta(car) {
      if (car.status === 'UNBOUND') {
        return { label: "未绑GPS", type: "warning", icon: carYellow };
      }
      if (car.status === 'OFFLINE') {
        return { label: "离线", type: "offline", icon: carGreen };
      }
      return { label: "运行中", type: "success", icon: carGreen };
    },
    getCarStatusOrder(car) {
      const statusType = this.getCarStatusMeta(car).type;
      return { success: 0, offline: 1, warning: 2 }[statusType] ?? 1;
    },
    hasGpsLocation(car) {
      const lng = car?.gpsLng;
      const lat = car?.gpsLat;
      return (
        lng !== null &&
        lng !== undefined &&
        String(lng).trim() !== "" &&
        lat !== null &&
        lat !== undefined &&
        String(lat).trim() !== "" &&
        Number.isFinite(Number(lng)) &&
        Number.isFinite(Number(lat))
      );
    },
    selectCar(car) {
      this.clickCarMarker({ target: { getExtData: () => car } });
      if (this.map && this.hasGpsLocation(car)) {
        this.map.setZoomAndCenter(13, [car.gpsLng, car.gpsLat]);
      }
    },
    async focusCar(car) {
      this.selectCar(car);
      if (!car.carId || !this.map || !this.AMap) return;
      try {
        const res = await getCarTrack(car.carId);
        const responseData = res && res.data ? res.data : {};
        if (res.status !== 200 || Number(responseData.code) !== 0) return;
        const rawPoints = Array.isArray(responseData.data)
          ? responseData.data
          : responseData.data && Array.isArray(responseData.data.list)
            ? responseData.data.list
            : [];
        const points = rawPoints
          // 轨迹为 GPS 原始 WGS84，转 GCJ02 后绘制
          .map((point) => wgs84ToGcj02(Number(point.lng), Number(point.lat)))
          .filter(([lng, lat]) => Number.isFinite(lng) && Number.isFinite(lat));
        if (points.length === 0) return;
        if (this.carTrackLine) this.map.remove(this.carTrackLine);
        if (points.length > 1) {
          this.carTrackLine = new this.AMap.Polyline({
            path: points.map(([lng, lat]) => new this.AMap.LngLat(lng, lat)),
            strokeColor: "#00f0f3",
            strokeWeight: 4,
            strokeOpacity: 0.9,
            showDir: true,
            zIndex: 120,
          });
          this.carTrackLine.setMap(this.map);
          this.map.setFitView([this.carTrackLine]);
        } else {
          this.map.setZoomAndCenter(15, points[0]);
        }
      } catch (error) {
        console.error("获取车辆轨迹失败", error);
      }
    },
    clickCarMarker(e) {
      this.closeSpotPopup();
      // console.log(e.target.getExtData());
      this.clickedCar = e.target.getExtData();
      if (!this.hasGpsLocation(this.clickedCar)) {
        this.clickedCar.address = "暂无GPS定位";
        return;
      }
      if (!this.clickedCar.address) {
        let position = [this.clickedCar.gpsLng, this.clickedCar.gpsLat]; //位置的经纬度
        new this.AMap.plugin("AMap.Geocoder", () => {
          const geocoder = new this.AMap.Geocoder();
          geocoder.getAddress(position, (status, result) => {
            if (status === "complete" && result.info === "OK") {
              // result为对应的地理位置详细信息
              this.clickedCar.address = result.regeocode.formattedAddress;
              // this.place为返回的具体地理位置信息，里面无法使用return回来！
            }
          });
        });
      }
    },
    async clickSpotMarker(e) {
      this.closeCarPopup();

      this.exceptionList = [];
      this.xunjianList = [];
      this.qingTaoList = [];
      this.clickBtn = 1;
      const spotId = e.target.getExtData();
      const spotInfo = this.spotMarkerDataMap[spotId];
      this.clickedSpot = spotInfo;
      this.showClickedSpot = true;

      const res1 = await getExceptionList1(spotId);

      if (res1.status === 200 && res1.data.code === 0) {
        this.xunjianList = res1.data.data;
      }

      const res0 = await getExceptionList0(spotId);

      if (res0.status === 200 && res0.data.code === 0) {
        this.exceptionList = res0.data.data;
      }

      const resQT = await getQingTaoRecords(spotId);

      if (resQT.status === 200 && resQT.data.code === 0) {
        this.qingTaoList = resQT.data.data;
      }
    },
    fullScreenClick() {
      this.isFullScreen = !this.isFullScreen;
    },
  },
};
</script>
<style scoped lang="less">
.overview-item-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: center;
  height: 80px;
  padding-right: 25px;
}

.overview-item-row > * {
  min-width: 0;
}

.task-overview {
  height: 100%;
  box-sizing: border-box;
  padding: 10px 18px 12px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
  color: #d8e2ff;
  cursor: pointer;
}

.task-group {
  min-height: 0;
}

.task-group-title {
  height: 24px;
  line-height: 24px;
  margin-bottom: 8px;
  overflow: hidden;
  color: #aebbd0;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-bottom: 1px solid rgba(108, 137, 180, 0.28);
}

.task-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.task-group-septic .task-stats {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.task-stat {
  min-width: 0;
  height: 72px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid rgba(43, 72, 119, 0.18);
  border-radius: 8px;
  background: rgba(20, 42, 77, 0.72);
}

.task-stat-label {
  color: #8e9bb0;
  font-size: 14px;
  line-height: 18px;
  white-space: nowrap;
}

.task-stat-value {
  margin-top: 2px;
  font-size: 22px;
  line-height: 26px;
  font-weight: 600;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.task-stat-value small {
  margin-left: 2px;
  font-size: 14px;
  font-weight: 600;
}

.task-stat-dispatched .task-stat-value {
  color: #438dff;
}

.task-stat-transit .task-stat-value {
  color: #ff9e32;
}

.task-stat-finished .task-stat-value {
  color: #00e88a;
}

.task-stat-residue .task-stat-value {
  color: #00d8f2;
}

.video-containerparent-wnd {
  margin: auto auto;
}

.header-controls {
  display: none;
}
.list-container::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.list-container::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(14, 82, 137, 1);
}

.list-container::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: rgb(21, 119, 199);
}

/* ========== 数据总览明细弹窗 ========== */
.overview-list-bg {
  display: flex;
  flex-direction: column;
  color: white;
  box-sizing: border-box;
  width: 1000px;
  max-width: calc(100vw - 20px);
  background-color: rgba(7, 23, 42, 0.94);
  background-image: none !important;
  height: min(615px, calc(100vh - 20px));
  max-height: calc(100vh - 20px);
  overflow: hidden;
  border: 1px solid rgba(55, 166, 255, 0.9);
  border-radius: 10px;
  box-shadow: 0 0 0 1px rgba(0, 126, 255, 0.35), inset 0 0 28px rgba(0, 126, 255, 0.16), 0 12px 34px rgba(0, 0, 0, 0.35);
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 200;
  transform: translate(-50%, -50%);

  .close-btn {
    cursor: pointer;
    position: absolute;
    width: 20px;
    height: 20px;
    top: 50%;
    right: 30px;
    transform: translate(0, -50%);
    background-repeat: no-repeat;
  }
}

.overview-dialog-header {
  flex: none;
  height: 58px;
  position: relative;
  display: flex;
  align-items: center;
  letter-spacing: 1px;
  padding-right: 70px;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(55, 166, 255, 0.24);
}

.overview-dialog-title {
  font-size: 20px;
  font-style: italic;
  font-weight: bold;
  margin-left: 45px;
}

.overview-dialog-toolbar {
  flex: none;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 48px;
  padding: 0 45px;
  box-sizing: border-box;
  background: rgba(7, 23, 42, 0.72);
}

.overview-dialog-search {
  width: 320px;
}

.overview-dialog-select {
  width: 150px;
}

.overview-dialog-toolbar .el-select .el-input__inner {
  color: #fff;
  background: rgba(12, 24, 40, 0.86);
  border-color: rgba(55, 166, 255, 0.7);
}

.overview-dialog-toolbar .el-input__inner {
  color: #fff;
  background: rgba(12, 24, 40, 0.86);
  border-color: rgba(55, 166, 255, 0.7);
}

.overview-dialog-toolbar .el-input__prefix,
.overview-dialog-toolbar .el-input__suffix {
  color: rgba(255, 255, 255, 0.75);
}

.overview-dialog-footer {
  flex: none;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 52px;
  padding: 0 45px 8px;
  box-sizing: border-box;
  position: relative;
  z-index: 3;
  background: rgba(7, 23, 42, 0.98);
  border-top: 1px solid rgba(55, 166, 255, 0.24);
}

.overview-dialog-footer .el-pagination {
  padding: 0;
  color: rgba(255, 255, 255, 0.85);
  transform: translateY(8px);
}

.overview-dialog-footer .el-pagination button,
.overview-dialog-footer .el-pagination .el-pager li {
  color: rgba(255, 255, 255, 0.85);
  background: rgba(20, 42, 77, 0.85);
}

.overview-dialog-footer .el-pagination button:hover,
.overview-dialog-footer .el-pagination .el-pager li:not(.disabled):hover {
  color: #fff;
  background: rgba(55, 166, 255, 0.35);
}

.overview-dialog-footer .el-pagination button:disabled {
  color: rgba(255, 255, 255, 0.35);
  background: rgba(20, 42, 77, 0.55);
}

.overview-dialog-footer .el-pagination .el-pager li.active {
  color: #fff;
  background: #37a6ff;
}

.overview-dialog-footer .el-pagination .el-pagination__sizes .el-input__inner {
  color: #fff;
  background: rgba(20, 42, 77, 0.85);
  border-color: rgba(55, 166, 255, 0.7);
}

.overview-dialog-footer .el-pagination .el-pagination__sizes .el-input__inner:focus {
  border-color: #37a6ff;
}

/* 可下钻行：手型 + 悬停高亮（.ov-cell 默认 cursor:default，需一并覆盖） */
.ov-row-clickable,
.ov-row-clickable .ov-cell {
  cursor: pointer;
}

.ov-row-clickable:hover {
  background: rgba(55, 166, 255, 0.16);
}
.ov-thead,
.ov-row {
  display: flex;
  text-align: center;
  justify-content: space-between;
  align-items: center;
  min-width: 0;
}

.ov-thead {
  flex: none;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  height: 44px;
  font-size: 16px;
  color: rgba(255, 255, 255, 1);
  font-weight: bold;
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgba(12, 24, 40, 0.96);
}

.ov-body {
  flex: none;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  margin: 0 0 12px;
  height: auto;
  overflow: visible;
}

.ov-table-scroll {
  flex: 1;
  min-width: 0;
  min-height: 0;
  width: calc(100% - 90px);
  margin: 0 45px;
  overflow: auto;
  padding-bottom: 8px;
  box-sizing: border-box;
  scrollbar-color: #37a6ff rgba(20, 42, 77, 0.85);
}

.ov-table-scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.ov-table-scroll::-webkit-scrollbar-track {
  background: rgba(20, 42, 77, 0.85);
  border-radius: 4px;
}

.ov-table-scroll::-webkit-scrollbar-thumb {
  background: #37a6ff;
  border-radius: 4px;
}

.ov-table-content {
  min-width: 100%;
  min-height: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;
  box-sizing: border-box;
}

/* 右侧可见滚动条（覆盖 .list-container 的 width:0 隐藏样式） */
.ov-body.list-container {
  scrollbar-width: auto; /* Firefox：恢复默认可见滚动条 */
  scrollbar-color: #37a6ff rgba(20, 42, 77, 0.85); /* Firefox：滑块/轨道配色 */
}

.ov-body.list-container::-webkit-scrollbar {
  width: 8px;
}

.ov-body.list-container::-webkit-scrollbar-track {
  background: rgba(20, 42, 77, 0.85);
  border-radius: 4px;
}

.ov-body.list-container::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #37a6ff, #1e5fa8);
  border-radius: 4px;
}

.ov-row {
  width: 100%;
  min-height: 46px;
  font-size: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.ov-col {
  min-width: 0;
  box-sizing: border-box;
  flex-shrink: 0;
  padding: 4px 2px;
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  word-break: break-all;
  line-height: 1.45;
}

.ov-thead .ov-col {
  white-space: nowrap;
  word-break: normal;
}

.ov-cell {
  cursor: default;
}

.ov-empty {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 16px;
}

.dynamic-detail-bg {
  display: flex;
  flex-direction: column;
  color: white;
  box-sizing: border-box;
  width: 1000px;
  max-width: calc(100vw - 20px);
  background-color: rgba(7, 23, 42, 0.94);
  background-image: none !important;
  height: min(615px, calc(100vh - 40px));
  min-height: 0;
  max-height: 615px;
  overflow: hidden;
  border: 1px solid rgba(55, 166, 255, 0.9);
  border-radius: 10px;
  box-shadow: 0 0 0 1px rgba(0, 126, 255, 0.35), inset 0 0 28px rgba(0, 126, 255, 0.16), 0 12px 34px rgba(0, 0, 0, 0.35);
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 201;
  transform: translate(-50%, -50%);
}

.dynamic-detail-bg .close-btn {
  cursor: pointer;
  position: absolute;
  width: 20px;
  height: 20px;
  top: 50%;
  right: 30px;
  transform: translate(0, -50%);
  background-repeat: no-repeat;
}

.dynamic-detail-body {
  flex: 1;
  min-height: 0;
  box-sizing: border-box;
  overflow-y: auto;
  margin: 0 70px 28px;
  font-size: 16px;
  scrollbar-width: thin;
  scrollbar-color: #37a6ff rgba(20, 42, 77, 0.85);
}

.dynamic-detail-body::-webkit-scrollbar {
  width: 8px;
}

.dynamic-detail-body::-webkit-scrollbar-track {
  background: rgba(20, 42, 77, 0.85);
  border-radius: 4px;
}

.dynamic-detail-body::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #37a6ff, #1e5fa8);
  border-radius: 4px;
}

.dynamic-detail-field {
  display: flex;
  align-items: flex-start;
  min-height: 48px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  line-height: 1.6;
}

.dynamic-detail-label {
  flex: none;
  width: 92px;
  color: #76b8ff;
}

.dynamic-detail-field > span:last-child {
  flex: 1;
  min-width: 0;
  white-space: pre-wrap;
  word-break: break-all;
}

.dynamic-detail-section {
  margin-top: 16px;
  padding: 8px 0;
  color: #37a6ff;
  font-size: 17px;
  font-weight: bold;
  border-bottom: 1px solid rgba(55, 166, 255, 0.35);
}

.dynamic-detail-photo-list {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dynamic-detail-photo {
  width: 72px;
  height: 72px;
  flex: none;
  border-radius: 4px;
  border: 1px solid rgba(55, 166, 255, 0.45);
  background: rgba(20, 42, 77, 0.85);
  cursor: pointer;
}

.dynamic-detail-photo-empty {
  color: rgba(255, 255, 255, 0.45);
}

@keyframes blink {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 1;
  }
}

:deep(.abnormal_marker) {
  animation: blink 1.5s infinite;
}

.page {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  position: relative;
  background-color: rgb(26, 35, 44);
  overflow: hidden;

  #container {
    width: 100vw;
    height: 940pt;
  }

  .spot-info-bg {
    display: flex;
    flex-direction: column;
    color: white;
    width: 500px;
    height: 617px;
    background-position: -38px -42px;
    background-origin: left top;
    position: fixed;
    top: 50%;
    left: 33%;
    z-index: 100;
    transform: translate(-50%, -50%);

    .close-btn {
      cursor: pointer;
      position: absolute;
      width: 20px;
      height: 20px;
      top: 50%;
      right: 30px;
      transform: translate(0, -30%);
      background-repeat: no-repeat;
    }

    .item {
      font-size: 16px;
      font-style: italic;
      height: 60px;
      display: flex;
      align-items: center;
      width: calc(100% - 60px);
      margin-left: 45px;
    }

    .item-border {
      border-bottom: 3px solid;
      border-image: linear-gradient(
          to right,
          rgba(53, 80, 111, 1),
          rgba(53, 80, 111, 0.2)
        )
        1;
    }

    .water-container {
      background-position: 30px 0px;
      font-size: 16px;
      position: relative;
    }

    .arrow-container {
      margin-top: -2rpx;
      background-color: transparent;
      border-top: 8px solid rgba(50, 143, 255, 0.5);
      border-bottom: 5px solid transparent;
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
    }
  }

  .spot-info-bg2 {
    border: 0px solid blue;
    display: flex;
    flex-direction: column;
    color: white;
    width: 561px;
    height: 615px;
    background-position: -38px -30px;
    background-origin: left top;
    position: fixed;
    top: 50%;
    right: 33%;
    z-index: 100;
    transform: translate(50%, -50%);

    .fullscreen-btn {
      cursor: pointer;
      position: absolute;
      width: 25px;
      height: 25px;
      top: 15%;
      right: 70px;
      transform: translate(0, -30%);
      background-repeat: no-repeat;
    }

    .close-btn {
      cursor: pointer;
      position: absolute;
      width: 20px;
      height: 20px;
      top: 50%;
      right: 30px;
      transform: translate(0, -30%);
      background-repeat: no-repeat;
    }
  }

  .spot-info-bg3 {
    display: flex;
    flex-direction: column;
    color: white;
    width: 500px;
    height: 617px;
    background-position: -38px -42px;
    background-origin: left top;
    /* 边框 PNG 中部透明，垫一层实底避免透出地图（与明细/任务详情弹窗同色） */
    background-color: rgba(7, 23, 42, 0.95);
    position: fixed;
    top: 50%;
    right: 33%;
    z-index: 202; /* 需高于明细列表(200)/任务详情(201)，从历史清掏记录下钻打开时置顶 */
    transform: translate(50%, -50%);
    border: 0px solid red;

    .close-btn {
      cursor: pointer;
      position: absolute;
      width: 20px;
      height: 20px;
      top: 50%;
      right: 30px;
      transform: translate(0, -30%);
      background-repeat: no-repeat;
    }

    .item {
      font-size: 16px;
      font-style: italic;
      height: 60px;
      display: flex;
      align-items: center;
      width: calc(100% - 60px);
      margin-left: 45px;
    }

    .item-border {
      border-bottom: 3px solid;
      border-image: linear-gradient(
          to right,
          rgba(53, 80, 111, 1),
          rgba(53, 80, 111, 0.2)
        )
        1;
    }

    .water-container {
      background-position: 30px 0px;
      font-size: 16px;
      position: relative;
    }

    .arrow-container {
      margin-top: -2rpx;
      background-color: transparent;
      border-top: 8px solid rgba(50, 143, 255, 0.5);
      border-bottom: 5px solid transparent;
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
    }
  }
  .camera-mini-bg {
    border: 0px solid blue;
    display: flex;
    flex-direction: column;
    color: white;
    width: 561px;
    height: 615px;
    background-position: -38px -30px;
    background-origin: left top;
    position: fixed;
    top: 50%;
    right: 33%;
    z-index: 1000000;
    transform: translate(50%, -50%);
    align-items: center;
    .fullscreen-btn {
      cursor: pointer;
      position: absolute;
      width: 25px;
      height: 25px;
      top: 15%;
      right: 70px;
      transform: translate(0, -30%);
      background-repeat: no-repeat;
    }

    .close-btn {
      cursor: pointer;
      position: absolute;
      width: 20px;
      height: 20px;
      top: 50%;
      right: 30px;
      transform: translate(0, -30%);
      background-repeat: no-repeat;
    }
  }
  .fullscreen-dialog-camera {
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    border: 0px solid red;
    display: flex;
    flex-direction: column;
    color: white;
    position: fixed;
    z-index: 1000002;
    background-color: rgb(26, 34, 43);

    .fullscreen-btn {
      cursor: pointer;
      position: absolute;
      width: 25px;
      height: 25px;
      top: 13%;
      right: 70px;
      transform: translate(0, -30%);
      background-repeat: no-repeat;
    }

    .close-btn {
      cursor: pointer;
      position: absolute;
      width: 20px;
      height: 20px;
      top: 50%;
      right: 30px;
      transform: translate(0, -30%);
      background-repeat: no-repeat;
    }
  }

  .video {
    display: flex;
    flex-direction: column;
    color: white;
    width: 500px;
    height: 500px;
    // border: 1px solid red;
    background-origin: left top;
    position: fixed;
    top: 50%;
    right: 20%;
    z-index: 103;
    transform: translate(0%, -50%);
  }

  .car-info-bg {
    display: flex;
    flex-direction: column;
    color: white;
    width: 500px;
    height: 320px;
    // border: 1px solid red;
    background-position: -38px -42px;
    background-origin: left top;
    position: fixed;
    top: 50%;
    left: 33%;
    z-index: 999999;
    transform: translate(-50%, -50%);

    .close-btn {
      cursor: pointer;
      position: absolute;
      width: 20px;
      height: 20px;
      top: 50%;
      right: 30px;
      transform: translate(0, -30%);
      background-repeat: no-repeat;
    }

    .item {
      font-size: 16px;
      font-style: italic;
      height: 60px;
      display: flex;
      align-items: center;
      width: calc(100% - 60px);
      margin-left: 45px;
    }

    .item-border {
      border-bottom: 3px solid;
      border-image: linear-gradient(
          to right,
          rgba(53, 80, 111, 1),
          rgba(53, 80, 111, 0.2)
        )
        1;
    }

    .water-container {
      background-position: 30px 0px;
      font-size: 16px;
      position: relative;
    }

    .arrow-container {
      margin-top: -2rpx;
      background-color: transparent;
      border-top: 8px solid rgba(50, 143, 255, 0.5);
      border-bottom: 5px solid transparent;
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
    }
  }

  .header {
    height: 173px;
    width: 100%;
    background-image: url("./assets/img/header.png");
    background-repeat: no-repeat;
    background-position: top;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    pointer-events: none;
  }

  .title {
    width: 100%;
    position: fixed;
    font-family: "Alimama ShuHeiTi";
    font-size: 18pt;
    font-weight: bold;
    color: #d1e5ff;
    letter-spacing: 8px;
    top: 9.5pt;
    left: 0%;
    text-align: center;
    z-index: 1002;
    pointer-events: none;
  }

  .logout-btn {
    position: fixed;
    top: 10pt;
    left: 20px;
    z-index: 1003;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 28px;
    padding: 0 12px;
    border: 1px solid rgba(64, 158, 255, 0.5);
    border-radius: 4px;
    background: rgba(16, 32, 52, 0.7);
    color: #d1e5ff;
    font-size: 13px;
    cursor: pointer;
    pointer-events: auto;

    &:hover,
    &:focus-visible {
      border-color: #409eff;
      background: rgba(64, 158, 255, 0.25);
      color: #fff;
      outline: none;
    }
  }

  .light {
    position: fixed;
    width: 100%;
    height: 140px;
    background-image: url("./assets/img/header-light.png");
    background-repeat: no-repeat;
    background-position: center;
    top: 0px;
    left: 0;
    z-index: 1001;
    pointer-events: none;
    border: 0px solid blue;
  }
  #video-container-wrap {
    margin: auto auto;
  }
  #video-container-headControl {
    display: none !important;
  }
}
.vehicle-monitor {
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 8px 16px 12px;
  color: rgba(255, 255, 255, 0.92);
  font-size: 15px;
}

.vehicle-row {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) 78px minmax(0, 1fr) 54px;
  align-items: center;
  min-height: 48px;
  column-gap: 8px;
  border-bottom: 1px solid rgba(67, 83, 143, 0.45);
  cursor: pointer;
}

.vehicle-row-header {
  min-height: 36px;
  color: rgba(157, 190, 225, 0.85);
  font-size: 13px;
  cursor: default;
  border-bottom-color: rgba(67, 83, 143, 0.65);
}

.vehicle-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.vehicle-name,
.vehicle-driver {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vehicle-status,
.vehicle-action {
  text-align: center;
}

.vehicle-status-tag {
  justify-self: start;
  min-width: 54px;
  box-sizing: border-box;
  padding: 3px 8px;
  border-radius: 10px;
  font-size: 12px;
  text-align: center;
}

.vehicle-status-success {
  color: #00f3a5;
  background: rgba(0, 182, 130, 0.18);
}

.vehicle-status-warning {
  color: #ffb42f;
  background: rgba(220, 143, 22, 0.2);
}

.vehicle-status-danger {
  color: #ff5b64;
  background: rgba(220, 47, 64, 0.2);
}

.vehicle-status-offline {
  color: #aab8c8;
  background: rgba(121, 139, 160, 0.2);
}

.vehicle-track {
  justify-self: center;
  box-sizing: border-box;
  min-width: 44px;
  padding: 3px 8px;
  color: #00d9ff;
  background: rgba(0, 81, 255, 0.12);
  border: 1px solid rgba(0, 177, 255, 0.6);
  border-radius: 4px;
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;
}

.vehicle-track:hover {
  background: rgba(0, 177, 255, 0.25);
}

.vehicle-empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.55);
}

.pool-overview-grid {
  height: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  align-items: center;
  justify-items: center;
  padding: 4px 18px 10px;
}
.pool-overview-grid > * {
  cursor: pointer;
}
/* 工作动态滚动列表：无缝循环滚动（滚到底自动衔接第一条），悬停暂停 */
.dynamic-scroll {
  height: 100%;
  box-sizing: border-box;
  padding: 4px 14px 6px 18px;
  overflow: hidden;
}
.dynamic-item {
  display: flex;
  align-items: flex-start;
  padding: 7px 4px;
  cursor: pointer;
}
.dynamic-item:hover {
  background: rgba(55, 166, 255, 0.12);
}
.dynamic-loop-run {
  animation: dynamic-marquee 60s linear infinite;
}
.dynamic-scroll:hover .dynamic-loop-run {
  animation-play-state: paused;
}
@keyframes dynamic-marquee {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}
/* 右侧面板列：锁总高，车辆实时监控吃满剩余（上面面板折叠时自动长高） */
.right-panel {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 93pt); /* 顶部 66.5pt + 底部对称留白 26.5pt */

  ::v-deep .container {
    flex-shrink: 0; /* 任务总览/池体总览固定高，不被压缩 */
  }
  ::v-deep .fill-box {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
  ::v-deep .fill-box .box-content {
    flex: 1;
    min-height: 0; /* 内部滚动列表随之撑满 */
  }
}
</style>

<style lang="less">
/* Element UI 的下拉菜单会挂到 body，使用全局样式保持大屏深色主题。 */
body > .el-select-dropdown {
  color: rgba(255, 255, 255, 0.9);
  background: rgba(12, 24, 40, 0.98);
  border-color: rgba(55, 166, 255, 0.7);
}

body > .el-select-dropdown .el-select-dropdown__item {
  color: rgba(255, 255, 255, 0.85);
  background: transparent;
}

body > .el-select-dropdown .el-select-dropdown__item.hover,
body > .el-select-dropdown .el-select-dropdown__item:hover {
  color: #fff;
  background: rgba(55, 166, 255, 0.3);
}

body > .el-select-dropdown .el-select-dropdown__item.selected {
  color: #37a6ff;
  background: rgba(55, 166, 255, 0.16);
}
</style>
